var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/sections/announcement-bar.js
import { timeline } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { EffectCarousel } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var AnnouncementBar = class extends EffectCarousel {
  connectedCallback() {
    this.style.removeProperty("max-height");
    super.connectedCallback();
  }
  get items() {
    const items = Array.from(this.querySelectorAll(".announcement-bar__middle-slide, .announcement-bar__message"));
    if (window.matchMedia("(min-width: 1280px)").matches) {
      return items.filter((item) => !item.classList.contains("announcement-bar__middle-slide"));
    }
    return items;
  }
  _transitionTo(fromSlide, toSlide) {
    timeline([
      [fromSlide, { transform: ["translateY(0)", "translateY(-5px)"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }],
      [toSlide, { transform: ["translateY(5px)", "translateY(0)"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 }]
    ]);
  }
};
if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", AnnouncementBar);
}

// js/sections/before-after-image.js
var SplitCursor = class extends HTMLElement {
  connectedCallback() {
    this._parentSection = this.closest(".shopify-section");
    this._dragging = false;
    this._offsetX = this._currentX = 0;
    this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this));
    this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this));
    this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this));
    window.addEventListener("resize", this._recalculateOffset.bind(this));
  }
  get minOffset() {
    return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
  }
  get maxOffset() {
    return this.offsetParent.clientWidth + this.minOffset;
  }
  _onPointerDown(event) {
    if (event.target === this || this.contains(event.target)) {
      this._initialX = event.clientX - this._offsetX;
      this._dragging = true;
    }
  }
  _onPointerMove(event) {
    if (!this._dragging) {
      return;
    }
    this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
    this._offsetX = this._currentX;
    this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
  }
  _onPointerUp() {
    this._dragging = false;
  }
  _recalculateOffset() {
    this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
  }
};
if (!window.customElements.get("split-cursor")) {
  window.customElements.define("split-cursor", SplitCursor);
}

// js/sections/collection-list.js
import { timeline as timeline2, inView } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
var CollectionList = class extends HTMLElement {
  constructor() {
        super();
        this._abortController = new AbortController();
        this.addEventListener("click", (event) => {
            this._onCollectionClicked.call(this, event);
        }, {
            signal: this._abortController.signal
        });

    }
    
    disconnectedCallback() {
        this._abortController.abort();
    }
    get controlledElement() {
        return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
    }
    
    _onCollectionClicked(event) {
        let item = event.target.closest('.collection-item');
        if(item) {
            const index = Number(item.getAttribute('index')) - 1;
            if (this.controlledElement) {
                this.controlledElement.dispatchEvent(new CustomEvent("control:select", {
                    bubbles: true,
                    cancelable: true,
                    detail: { index }
                }));
            }

        }
    }
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView(this, this._reveal.bind(this), { margin: "-100px" });
    }
  }
  _reveal() {
    const toReveal = Array.from(this.querySelectorAll("[reveal-js]"));
    timeline2([
      [toReveal, { opacity: 1 }, { duration: 0 }],
      [toReveal.map((item) => item.querySelector("img, svg")), { opacity: [0, 1], transform: ["scale(1.03)", "auto"] }, { duration: 0.2 }],
      [toReveal.map((item) => item.querySelector(".collection-card__content-wrapper")), { opacity: [0, 1] }, { duration: 0.2 }]
    ]);
  }
};
if (!window.customElements.get("collection-list")) {
  window.customElements.define("collection-list", CollectionList);
}

// js/sections/customer-login.js
import { Delegate } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
var AccountLogin = class extends HTMLElement {
  connectedCallback() {
    // 获取 return_url 或者 return_to URL参数
    const returnUrl = new URLSearchParams(window.location.search).get("return_url") || new URLSearchParams(window.location.search).get("return_to");
    if (returnUrl) {
      this.querySelector('[name="checkout_url"]').value = returnUrl
      
      const signUpWrapper = document.querySelector('#customer_login .sign-up-wrapper');
      if (signUpWrapper && signUpWrapper.href) {
        signUpWrapper.href = `${signUpWrapper.href}?return_url=${returnUrl}`
      }
    }
    
    this.recoverForm = this.querySelector("#recover");
    this.loginForm = this.querySelector("#login");
    if (window.location.hash === "#recover") {
      this._switchForms();
    }
    new Delegate(this).on("click", '[href="#recover"], [href="#login"]', this._switchForms.bind(this));
  }
  _switchForms(event) {
    if (event) {
      event.preventDefault();
    }
    this.recoverForm.hidden = !this.recoverForm.hidden;
    this.loginForm.hidden = !this.loginForm.hidden;
  }
};
if (!window.customElements.get("account-login")) {
  window.customElements.define("account-login", AccountLogin);
}

// js/sections/header.js
import { animate, timeline as timeline3, stagger, Delegate as Delegate2 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { AnimatedDetails, EffectCarousel as EffectCarousel2, Drawer, throttle } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var reduceMenuAnimation = JSON.parse("false");
var StoreHeader = class extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute("hide-on-scroll") && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._lastScrollTop = 0;
      this._accumulatedScroll = 0;
      this._isVisible = true;
      this._hasSwitchedToSticky = false;
      window.addEventListener("scroll", throttle(this._onScroll.bind(this)));
    }
    this.addEventListener("toggle", this._checkTransparency.bind(this), { capture: true });
    if (this.hasAttribute("sticky")) {
      this._setupTransparentHeader();
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:unload", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:reorder", this._setupTransparentHeader.bind(this));
      }
    }
  }
  /**
   * The sticky box is the header section, not this element: moving only the inner header would
   * leave an empty band at the top of the viewport that still catches clicks.
   */
  get _stickyTarget() {
    return this.closest(".shopify-section") ?? this;
  }
  hide() {
    if (this._isVisible) {
      animate(this._stickyTarget, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.2, easing: "ease" });
      this._isVisible = false;
      this._syncVisibility();
    }
  }
  show() {
    if (!this._isVisible) {
      animate(this._stickyTarget, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.2, easing: "ease" });
      this._accumulatedScroll = 0;
      this._isVisible = true;
      this._syncVisibility();
    }
  }
  /**
   * Publish the header state so sticky elements below it (anchor tabs, product info, compare bars)
   * can move up into the freed space. Event contract: `header:visibility-change`, bubbling from the
   * document, with `detail: { visible: boolean }`.
   */
  _syncVisibility() {
    document.documentElement.style.setProperty("--header-is-visible", this._isVisible ? "1" : "0");
    document.dispatchEvent(new CustomEvent("header:visibility-change", { detail: { visible: this._isVisible } }));
  }
  _onScroll() {
    if (window.scrollY < 0) {
      return;
    }
    this._accumulatedScroll = Math.max(0, this._accumulatedScroll + (window.scrollY - this._lastScrollTop));
    if (window.scrollY < this._lastScrollTop) {
      this.show();
    } else if (this._accumulatedScroll > parseInt(this.getAttribute("hide-on-scroll")) && !this.querySelector("[open]")) {
      this.hide();
    }
    this._lastScrollTop = window.scrollY;
  }
  _checkTransparency() {
    let hasFallbackScrollDetection = false;
    if (CSS.supports("selector(:has(> *))") && this.hasAttribute("sticky") && !this.hasAttribute("hide-on-scroll") && this.hasAttribute("allow-transparency")) {
      const offsetBeforeChanging = 500;
      if (this.querySelectorAll("[open]").length > 0) {
        this.classList.add("is-filled");
      } else if (window.scrollY >= offsetBeforeChanging && !this._hasSwitchedToSticky) {
        this._hasSwitchedToSticky = true;
        this.classList.add("is-filled");
        animate(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.15, easing: "ease" });
      } else if (window.scrollY < offsetBeforeChanging) {
        if (this._hasSwitchedToSticky) {
          this._hasSwitchedToSticky = false;
          animate(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.15, easing: "ease" }).finished.then(() => {
            this.style.transform = null;
            this.classList.remove("is-filled");
          });
        } else if (this.getAnimations().length === 0) {
          this.classList.remove("is-filled");
        }
      }
    } else {
      hasFallbackScrollDetection = window.scrollY > 20;
      this.classList.toggle("is-filled", !this.hasAttribute("allow-transparency") || this.querySelectorAll("[open]").length > 0 || hasFallbackScrollDetection);
    }
  }
  _setupTransparentHeader() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
      this.setAttribute("allow-transparency", "");
      window.addEventListener("scroll", throttle(this._checkTransparency.bind(this)));
      this.addEventListener("mouseenter", this._checkTransparency.bind(this));
      this.addEventListener("mouseleave", this._checkTransparency.bind(this));
      this._checkTransparency();
    } else {
      this.removeAttribute("allow-transparency");
    }
  }
};
var DropdownDisclosure = class extends AnimatedDetails {
  constructor() {
    super();
    this._detectClickOutsideListener = this._detectClickOutside.bind(this);
    this._detectEscKeyboardListener = this._detectEscKeyboard.bind(this);
    this._detectFocusOutListener = this._detectFocusOut.bind(this);
    this._detectHoverListener = this._detectHover.bind(this);
    this._hoverTimer = null;
    this._header = document.querySelector(".shopify-section--header");
    this.addEventListener("mouseover", this._detectHoverListener.bind(this));
    this.addEventListener("mouseout", this._detectHoverListener.bind(this));
  }
  get trigger() {
    return !window.matchMedia("screen and (pointer: fine)").matches ? "click" : this.getAttribute("trigger");
  }
  get mouseOverDelayTolerance() {
    return 250;
  }
  /**
   * When the summary is clicked and that the mode is hover, we follow the link (if set) that may have been specified
   * on the parent. If the mode is click, then we deferred to the default behavior of the "AnimatedDetails" parent
   */
  _onSummaryClicked(event) {
    if (this.trigger === "hover") {
      event.preventDefault();
      if (event.currentTarget.hasAttribute("data-url")) {
        window.location.href = event.currentTarget.getAttribute("data-url");
      }
    } else {
      super._onSummaryClicked(event);
    }
  }
  async _transition(value) {
    if (value) {
      this.setAttribute("open", "");
      document.addEventListener("click", this._detectClickOutsideListener);
      document.addEventListener("keydown", this._detectEscKeyboardListener);
      document.addEventListener("focusout", this._detectFocusOutListener);
      const openSiblings = Array.from(this.closest("ul").querySelectorAll("[open]")).filter((item) => item !== this);
      openSiblings.forEach((sibling) => sibling.open = false);
      await this._transitionIn(openSiblings.length > 0);
    } else {
      document.removeEventListener("click", this._detectClickOutsideListener);
      document.removeEventListener("keydown", this._detectEscKeyboardListener);
      document.removeEventListener("focusout", this._detectFocusOutListener);
      await this._transitionOut();
      this.removeAttribute("open");
    }
  }
  _transitionIn(hasOpenSiblings = false) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }]];
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      timelineSequence.push([this.contentElement.querySelectorAll(":scope > ul > li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { delay: stagger(0.025), at: "-0.1", duration: 0.2 }]);
    }
    return timeline3(timelineSequence, { delay: hasOpenSiblings > 0 ? 0.1 : 0 }).finished;
  }
  _transitionOut() {
    return timeline3([[this.contentElement, { opacity: 0 }, { duration: 0.2 }]]).finished;
  }
  /**
   * When dropdown menu is configured to open on click, we add a listener to detect click outside and automatically
   * close the navigation.
   */
  _detectClickOutside(event) {
    if (this.trigger !== "click") {
      return;
    }
    if (!this.contains(event.target) && !(event.target.closest("details") instanceof DropdownDisclosure)) {
      this.open = false;
    }
  }
  /**
   * On desktop device, if the mode is set to hover, we open/close the dropdown on hover
   */
  _detectHover(event) {
    if (this.trigger !== "hover") {
      return;
    }
    if (event.type === "mouseover") {
      this.open = true;
      clearTimeout(this._hoverTimer);
    } else {
      this._hoverTimer = setTimeout(() => this.open = false, this.mouseOverDelayTolerance);
    }
  }
  /**
   * Detect if we hit the "Escape" key to automatically close the dropdown
   */
  _detectEscKeyboard(event) {
    if (event.code === "Escape") {
      const targetMenu = event.target.closest("details[open]");
      if (targetMenu) {
        targetMenu.open = false;
      }
    }
  }
  /**
   * Close the dropdown automatically when the dropdown is focused out
   */
  _detectFocusOut(event) {
    if (event.relatedTarget && !this.contains(event.relatedTarget)) {
      this.open = false;
    }
  }
  
  // 1. 定义需要观察的属性
  static get observedAttributes() {
    return ['open']; // 假设你监听的是名为 'open' 的 HTML 属性
    // 如果是 data 属性，则写 'data-open'
  }
  
  // 2. 当 observedAttributes 中的属性发生变化时，此方法会被调用
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this._handleOpenChange();
    }
  }
  
  // 你可以创建一个私有方法来处理 open 属性变化后的具体逻辑
  _handleOpenChange(isOpen) {
    // 不应该只判断当前 mega-menu-disclosure, 而是判断所有 mega-menu-disclosure 的状态
    const allItems = this._header.querySelectorAll(".disclosure-details");
   
    const hasOpen = Array.from(allItems).some((item) => item.open);
      
    if (hasOpen) {
      this._header.style.zIndex = "100";     
      // 阻止底层页面滚动
      document.documentElement.classList.add('country-modal-open');
    } else {
      this._header.style.zIndex = "10";    
      document.documentElement.classList.remove('country-modal-open');
    }
  }
  
};
var MegaMenuDisclosure = class extends DropdownDisclosure {
  constructor() {
    super();
    this._header = document.querySelector(".shopify-section--header");
    this.addEventListener("pointerover", this._preloadImages.bind(this));
    this._class = this.className;
  }
  get mouseOverDelayTolerance() {
    return 500;
  }
  
  // 1. 定义需要观察的属性
  static get observedAttributes() {
    return ['open']; // 假设你监听的是名为 'open' 的 HTML 属性
    // 如果是 data 属性，则写 'data-open'
  }
  
  // 2. 当 observedAttributes 中的属性发生变化时，此方法会被调用
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      // 根据属性是否存在或其值来判断
      const isOpen = this.hasAttribute('open') || (newValue === 'true'); // 检查是否存在 'open' 属性，或值是否为 'true'

      if (isOpen && oldValue !== newValue) { // 确保是属性变为打开状态且值有变化
        // 在这里执行你希望在 open 变为 true 时触发的逻辑
        this._handleOpenChange(isOpen);
      } else if (!isOpen && oldValue !== newValue) { // 属性变为关闭状态
        // 在这里执行你希望在 open 变为 false 时触发的逻辑
        this._handleOpenChange(isOpen);
      }
    }
  }
  
  // 你可以创建一个私有方法来处理 open 属性变化后的具体逻辑
  _handleOpenChange(isOpen) {
    // 不应该只判断当前 mega-menu-disclosure, 而是判断所有 mega-menu-disclosure 的状态
    const allMegaMenuDisclosures = this._header.querySelectorAll(".disclosure-details");
   
    const hasOpen = Array.from(allMegaMenuDisclosures).some((item) => item.open);
      
    if (hasOpen) {
      this._header.style.zIndex = "100";     
      // 阻止底层页面滚动
      document.documentElement.classList.add('country-modal-open');
    } else {
      this._header.style.zIndex = "10";    
      document.documentElement.classList.remove('country-modal-open');
    }
  }
    
  async _transition(value) {
    const header = document.querySelector('header'); // 选择 header 元素
    if (value) {
        this.setAttribute("open", "");
        
        // 在打开时添加 Class A
        if (header) {
          header.classList.add('header-focus-z-index'); // 添加类
        }

        document.addEventListener("click", this._detectClickOutsideListener);
        document.addEventListener("keydown", this._detectEscKeyboardListener);
        document.addEventListener("focusout", this._detectFocusOutListener);
        
        const openSiblings = Array.from(this.closest("ul").querySelectorAll("[open]")).filter((item) => item !== this);
        openSiblings.forEach((sibling) => sibling.open = false);
        
        await this._transitionIn(openSiblings.length > 0);
    } else {
        // 在关闭时移除 Class A
        if (header) {
          header.classList.remove('header-focus-z-index'); // 移除类
        }

        document.removeEventListener("click", this._detectClickOutsideListener);
        document.removeEventListener("keydown", this._detectEscKeyboardListener);
        document.removeEventListener("focusout", this._detectFocusOutListener);
        
        await this._transitionOut();
        this.removeAttribute("open");
    }
  }
  _transitionIn(hasOpenSiblings) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }], "mega-menu"], contentDelay = hasOpenSiblings ? 0.1 : 0;
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      this.contentElement.querySelectorAll(".mega-menu__promo").forEach((promo) => {
        timelineSequence.push([promo, { opacity: [0, 1] }, { duration: 0.25, delay: contentDelay, at: "mega-menu" }], "mega-menu-promo");
      });
      this.contentElement.querySelectorAll(".mega-menu__nav > li").forEach((column) => {
        timelineSequence.push([column.querySelectorAll(":scope > :first-child, :scope li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", delay: stagger(0.025, { start: contentDelay }), at: "mega-menu", duration: 0.2 }]);
      });
    }
    return timeline3(timelineSequence).finished;
  }
  /**
   * When the toggle is hovered we preload the mega-menu images to improve perceived performance
   */
  _preloadImages() {
    Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((image) => image.setAttribute("loading", "eager"));
  }
};
var MegaMenuPromoCarousel = class extends EffectCarousel2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.nextElementSibling) {
      this.addEventListener("carousel:select", (event) => this._updateControlsColor(event.detail.slide));
    }
    this._updateControlsColor(this.items[this.selectedIndex]);
  }
  _updateControlsColor(slide) {
    const extractFrom = slide.classList.contains("content-over-media") ? slide : slide.firstElementChild;
    this.nextElementSibling.style.setProperty("--text-color", extractFrom.style.getPropertyValue("--text-color"));
  }
};
var NavigationDrawer = class extends Drawer {
  constructor() {
    super();
    const delegate = new Delegate2(this);
    delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
    this._isTransitioning = false;
    this.addEventListener("dialog:after-hide", () => {
      this.reinitializeDrawer();
    });
  }
  get openFrom() {
    return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
  }
  // Used for navigation mobile and navigation desktop set to drawer
  switchToPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let panelToHideTransform, panelToShowTransform, panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper"), timelineSequence = [];
    if (document.dir === "rtl") {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
    } else {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
    }
    timelineSequence.push(
      [panelToHide, { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.3, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }],
      "panelHidden",
      [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform }, { at: "<", transform: { duration: 0.3 } }]
    );
    if (linkListIndex !== null) {
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    timeline3(timelineSequence);
  }
  // Used when mega menu is set to drawer
  showPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let timelineSequence = [], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper");
    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timelineSequence.push(
        [this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.2 }],
        [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
      );
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
      timelineSequence.push([linkLists[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }]);
    }
    timeline3(timelineSequence).finished.then(() => {
      if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
        linkLists[this.previousLinkIndex].removeAttribute("style");
      }
      if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
        timeline3([this.switchLinkList(linkLists, linkListIndex)]);
      }
      this.previousLinkIndex = linkListIndex;
      panelToShow.setAttribute("open", "");
      this._isTransitioning = false;
    });
  }
  switchLinkList(linkLists, linkListIndex) {
    Array.from(linkLists).forEach((item) => {
      item.setAttribute("hidden", "");
    });
    linkLists[linkListIndex].removeAttribute("hidden");
    return [linkLists[linkListIndex].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.2, at: "-0.15", delay: stagger(0.025, { start: 0.1 }) }];
  }
  // Set navigation drawer to initial state when drawer closed
  reinitializeDrawer() {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.style.removeProperty("width");
      this.setExpanded();
    } else {
      const firstPanel = this.querySelector(".panel:first-child");
      firstPanel.style.opacity = "1";
      firstPanel.style.visibility = "visible";
      firstPanel.style.transform = "translateX(0%)";
    }
    Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
      if (this.hasAttribute("mega-menu")) {
        item.removeAttribute("open");
      }
      item.style.opacity = "0";
      item.style.visibility = "hidden";
      Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
    });
  }
  setExpanded(target) {
    Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });
    if (target) {
      target.setAttribute("aria-expanded", "true");
    }
  }
  _onPanelButtonClick(event, target) {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      // PC 端
      this.setExpanded(target);
      this.showPanel(...target.getAttribute("data-panel").split("-"));
    } else {
      // Mobile 端
      // this.switchToPanel(...target.getAttribute("data-panel").split("-"));
      const panelWrapper = target.closest('.li-panel-wrapper').querySelector('.mobile-panel__wrapper');
      // 判断当前是否打开状态
      const hasHiddenFlag = panelWrapper.hasAttribute('hidden');
      
      this.querySelectorAll('.mobile-panel__wrapper').forEach((item) => {
        item.setAttribute('hidden', '');
      })
      
      Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
        item.setAttribute("aria-expanded", "false");
      });
      
      if(hasHiddenFlag) {
        const panelIndex = target.getAttribute("data-panel");
        console.log('panelWrapper: ', panelWrapper);
        panelWrapper.removeAttribute('hidden');
        target.setAttribute("aria-expanded", "true");
      }
    }
  }
};
if (!window.customElements.get("store-header")) {
  window.customElements.define("store-header", StoreHeader);
}
if (!window.customElements.get("dropdown-disclosure")) {
  window.customElements.define("dropdown-disclosure", DropdownDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-disclosure")) {
  window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-promo-carousel")) {
  window.customElements.define("mega-menu-promo-carousel", MegaMenuPromoCarousel);
}
if (!window.customElements.get("navigation-drawer")) {
  window.customElements.define("navigation-drawer", NavigationDrawer);
}

// js/sections/feature-chart.js
import { animate as motionAnimate, scroll } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
var FeatureChart = class extends HTMLElement {
  connectedCallback() {
    this.viewButtonElement = this.querySelector('[data-action="toggle-rows"]');
    this.featureChartTable = this.querySelector(".feature-chart__table");
    this.featureChartRows = Array.from(this.featureChartTable.childNodes);
    this.featureProductRow = this.querySelector(".feature-chart__table-row--product");
    this.featureChartSticky = this.querySelector(".feature-chart__table-row--sticky");
    if (this.viewButtonElement) {
      this.viewButtonElement.addEventListener("click", this._toggleRows.bind(this));
    }
    if (this.featureChartSticky) {
      this.featureChartSticky.style.width = `${this.featureChartTable.scrollWidth}px`;
      this.featureChartTable.addEventListener("scroll", (event) => {
        this.featureChartSticky.style.marginLeft = -1 * event.target.scrollLeft + "px";
      });
      new ResizeObserver((entries) => {
        this.featureChartSticky.style.width = `${entries[0].contentRect.width}px`;
      }).observe(this.featureChartTable);
      const offset = getComputedStyle(this).scrollPaddingTop;
      scroll(({ y }) => {
        if (y.current >= y.targetOffset + this.featureProductRow.clientHeight / 2 && y.progress < 0.85) {
          this.featureChartSticky.classList.add("is-visible");
        } else {
          this.featureChartSticky.classList.remove("is-visible");
        }
      }, {
        target: this.featureChartTable,
        offset: [`${offset} start`, `end ${offset}`]
      });
    }
  }
  _toggleRows() {
    if (this.classList.contains("is-expanded")) {
      this._hideRows();
    } else {
      this._showRows();
    }
  }
  async _showRows() {
    const fromHeight = this.featureChartTable.clientHeight;
    this.featureChartRows.forEach((row) => {
      row.hidden = false;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-less");
    this.classList.add("is-expanded");
    await motionAnimate(this.featureChartTable, { height: [`${fromHeight}px`, `${this.featureChartTable.clientHeight}px`] }).finished;
    this.featureChartTable.style.height = "auto";
  }
  async _hideRows() {
    let fromHeight = this.featureChartTable.clientHeight, toHeight = 0;
    this.featureChartRows.slice(0, parseInt(this.getAttribute("max-rows"))).forEach((row) => {
      toHeight += row.clientHeight;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-more");
    this.classList.remove("is-expanded");
    await motionAnimate(this.featureChartTable, { height: [`${fromHeight}px`, `${toHeight}px`] }).finished;
    this.featureChartRows.slice(parseInt(this.getAttribute("max-rows"))).forEach((row) => row.hidden = true);
    this.featureChartTable.style.height = "auto";
  }
};
if (!window.customElements.get("feature-chart")) {
  window.customElements.define("feature-chart", FeatureChart);
}

// js/sections/image-banner.js
import { scroll as scroll2, timeline as timeline4, animate as animate2, inView as inView2 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { imageLoaded, getHeadingKeyframe } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var ImageBanner = class extends HTMLElement {
  connectedCallback() {
    if (this.parallax && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._setupParallax();
    }
    inView2(this, async () => {
      await imageLoaded(Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")));
      const headings = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
      timeline4([
        [this, { opacity: [0, 1] }, { duration: 0.25 }],
        ...headings.map((heading) => [...getHeadingKeyframe(heading)])
      ]);
    });
  }
  get parallax() {
    return this.hasAttribute("parallax") ? parseFloat(this.getAttribute("parallax")) : false;
  }
  _setupParallax() {
    const media = Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")), [scale, translate] = [1 + this.parallax, this.parallax * 100 / (1 + this.parallax)];
    scroll2(
      animate2(media, { transform: [`scale(${scale}) translateY(${translate}%)`, `scale(${scale}) translateY(0)`] }, { easing: "linear" }),
      {
        target: this,
        offset: ["start end", "end start"]
      }
    );
  }
};
if (!window.customElements.get("image-banner")) {
  window.customElements.define("image-banner", ImageBanner);
}

// js/sections/image-link-blocks.js
import { ScrollArea } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var ImageLinkBlocks = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    new ScrollArea(this);
    this.addEventListener("control:prev", this._prev);
    this.addEventListener("control:next", this._next);
  }
  _prev() {
    this.scrollBy({ left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth, behavior: "smooth" });
  }
  _next() {
    this.scrollBy({ left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth, behavior: "smooth" });
  }
};
if (!window.customElements.get("image-link-blocks")) {
  window.customElements.define("image-link-blocks", ImageLinkBlocks);
}

// js/sections/images-with-text-scrolling.js
import { animate as animate3, timeline as timeline5, inView as inView3 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { getHeadingKeyframe as getHeadingKeyframe2, throttle as throttle2 } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var ImagesWithTextScrolling = class extends HTMLElement {
  connectedCallback() {
    inView3(this, this._reveal.bind(this));
    if (this.hasAttribute("scrolling-experience")) {
      this._imageToTransitionItems = Array.from(this.querySelectorAll(".images-scrolling-desktop__media-wrapper > :not(:first-child)"));
      this._mainImage = this.querySelector(".images-scrolling-desktop__media-wrapper > :first-child");
      this._contentItems = Array.from(this.querySelectorAll(".images-scrolling__content"));
      if (this._imageToTransitionItems.length > 0) {
        window.addEventListener("scroll", throttle2(this._onScroll.bind(this)));
      }
    }
  }
  _reveal() {
    Array.from(this.querySelectorAll('[reveal-on-scroll="true"]')).forEach((heading) => {
      animate3(...getHeadingKeyframe2(heading));
    });
  }
  _onScroll() {
    const imageRect = this._mainImage.getBoundingClientRect(), imageBottom = imageRect.bottom, imageEffect = this.getAttribute("scrolling-experience");
    for (const [index, contentItem] of this._contentItems.entries()) {
      const contentItemRect = contentItem.getBoundingClientRect(), image = this._imageToTransitionItems[index - 1], content = this._contentItems[index];
      if (contentItemRect.top < imageBottom - imageRect.height * 0.15 && contentItemRect.bottom > imageBottom) {
        if (image && !image.classList.contains("is-visible")) {
          image.classList.add("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 1] }, { duration: 0.2 }],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }]
            ]);
          } else {
            timeline5([
              [image, { opacity: [null, 1], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }]
            ]);
          }
        }
        break;
      }
      if (contentItemRect.top > imageBottom - imageRect.height * 0.15) {
        if (image && image.classList.contains("is-visible")) {
          image.classList.remove("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 0] }, { duration: 0.2 }],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }]
            ]);
          } else {
            timeline5([
              [image, { opacity: [null, 1], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }]
            ]);
          }
        }
        break;
      }
    }
  }
};
if (!window.customElements.get("images-with-text-scrolling")) {
  window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);
}

// js/sections/impact-text.js
import { animate as animate4, inView as inView4 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
var ImpactText = class extends HTMLElement {
  connectedCallback() {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      return;
    }
    inView4(this, ({ target }) => this._onBecameVisible(target), { margin: "-100px" });
  }
  async _onBecameVisible(target) {
    animate4(target, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 });
    if (this.hasAttribute("count-up")) {
      const itemToSearch = this.childElementCount === 0 ? this : this.firstElementChild, matches = itemToSearch.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
      if (!matches) {
        return;
      }
      itemToSearch.innerHTML = itemToSearch.textContent.replace(/\d+(?:[,. ]\d+)*/, `<span>${matches[0]}</span>`);
      const numberSpan = itemToSearch.querySelector("span");
      numberSpan.style.textAlign = matches[0] === matches["input"] ? null : "end";
      if (!itemToSearch.classList.contains("text-gradient")) {
        numberSpan.style.display = "inline-block";
        numberSpan.style.minWidth = `${numberSpan.clientWidth}px`;
      }
      const toReplace = matches[0].replace(/[,\. ]+/, ""), charactersMatches = [...matches[0].matchAll(/[,\. ]+/g)];
      await animate4((progress) => {
        let formattedString = Math.round(progress * parseInt(toReplace)).toString();
        charactersMatches.forEach((character) => {
          if (formattedString.length >= matches[0].length - character.index) {
            formattedString = formattedString.slice(0, character.index) + character[0] + formattedString.slice(character.index);
          }
        });
        numberSpan.textContent = progress === 1 ? matches[0] : formattedString;
      }, { duration: parseFloat(this.getAttribute("count-up")), easing: [0.16, 1, 0.3, 1] }).finished;
      numberSpan.style.minWidth = null;
    }
  }
};
if (!window.customElements.get("impact-text")) {
  window.customElements.define("impact-text", ImpactText);
}

// js/sections/media-grid.js
import { timeline as timeline6, inView as inView5 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
var MediaGrid = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    if (this.dataset.disableRevealMotion === "true") {
      this._applyStaticState();
      return;
    }
    if (this._revealInitialized) {
      return;
    }
    this._revealInitialized = true;
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView5(this, this._onBecameVisible.bind(this));
    }
  }
  _applyStaticState() {
    this.items.forEach((item) => {
      item.style.opacity = "1";
      item.style.transform = "";
    });
  }
  _onBecameVisible() {
    if (this._hasRevealed) {
      return;
    }
    this._hasRevealed = true;
    const contentElements = this.querySelectorAll(".content-over-media > :not(img, video, iframe, svg, video-media, native-video, external-video)");
    timeline6([
      [this.items, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }],
      [contentElements, { opacity: [0, 1] }, { duration: 0.2, at: "+0.1" }]
    ]);
  }
};
if (!window.customElements.get("media-grid")) {
  window.customElements.define("media-grid", MediaGrid);
}

// js/sections/media-grid.js
import {timeline as wlzTimeline6, inView as wlzInView5} from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
var CShow = class extends HTMLElement {
    connectedCallback() {
        this.items = Array.from(this.children);
        // Country landing page must keep first-paint height; skip the entrance motion.
        // PC SweetAlert still lives outside this section and keeps the animation.
        if (this.closest('.shopify-section__choose-country-region')) {
            return;
        }
        if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
            wlzInView5(this, this._onBecameVisible.bind(this));
        }
    }

    _onBecameVisible() {
        wlzTimeline6([
            [this.items, {opacity: [0, 1], transform: ["translateY(64px)", "translateY(0)"]}, {duration: 0.4}],
        ]);
    }
};
if (!window.customElements.get("c-show")) {
    window.customElements.define("c-show", CShow);
}

// js/sections/custom-scroll-grid.js
var ScrollGrid = class extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // 读取自定义属性来控制是否启用滑动
        this.enableScroll = this.getAttribute('data-enable-scroll') == 'true'; // 默认禁用
        this.scrollSpeed = parseFloat(this.getAttribute('data-scroll-speed')) || 0.5; // 默认滑动速度为0.5
        this.sectionID = this.getAttribute('section-id'); 
        this.scrollOuterMax = document.getElementById(`shopify-section-${this.sectionID}`) 
        this.scrollOuter = document.getElementById(`scroll-grid__outer-${this.sectionID}`);
        this.scrollWrap = document.getElementById(`scroll-grid__wrap-${this.sectionID}`);
        this.scrollBox = this.querySelector('.scroll-grid-box');
        this.scrollItems = this.querySelectorAll('scroll-grid__item');
        // this.triggerScrollPosition = null;

        // window.addEventListener('scroll', this._onScroll.bind(this));

        if (this.enableScroll && this.scrollWrap) {
            this._onScroll(); // 调用一次
            new IntersectionObserver(this._onVisibilityChanged.bind(this), { rootMargin: "0px 0px 0px 0px" }).observe(this.scrollWrap);
        }

    }

    _onVisibilityChanged(entries) {
        if (entries[0].isIntersecting) { 
            console.log('Intersection observed:', entries[0].isIntersecting, entries[0].boundingClientRect);
            if (this.enableScroll) {
                window.addEventListener('scroll', this._onScroll.bind(this));
                this.isScrollListenerAdded = true;
            }
        } else if (!entries[0].isIntersecting && this.isScrollListenerAdded) {
            console.log(' out -------')
            window.removeEventListener('scroll', this._onScroll.bind(this));
            this.isScrollListenerAdded = false;
        }
    }

    _onScroll() {
        this.scrollWrap.style.height = `${this.scrollBox.offsetWidth}px +`;
        // const scrollPosition = window.scrollY; 
        const rect = this.scrollOuter.getBoundingClientRect();
        const scrollPosition = rect.top; 
        const translateValue = -scrollPosition * this.scrollSpeed;

        const scrollPositionBottom = rect.bottom;
        // console.log('scrollPositionBottom---', scrollPositionBottom);
        
        this.trigger_distance = this.scrollOuterMax.offsetTop;
        this.distance = scrollY - this.trigger_distance;
        const positionY = innerHeight * 0.1;
        this.border_distance = this.scrollOuterMax.offsetTop + this.scrollOuterMax.offsetHeight - innerHeight;
        let distance_x =
            this.distance / (this.border_distance - this.trigger_distance) *
            (this.scrollBox.offsetWidth - innerWidth) * this.scrollSpeed;
        // let opacity = Math.min(1, translateValue / (scrollPosition * 2));
        // opacity = Math.max(0, opacity);

        // const scrollWidth = this.scrollBox.scrollWidth
        // const width = rect.right;
        // console.log('distance_x', distance_x, positionY)
        // console.log('opacity', opacity,'scrollPosition', scrollPosition,'width', width,'scrollWidth',scrollWidth)
        // console.log('this.scrollOuterMax.offsetTop', scrollPosition,this.trigger_distance, window.scrollY, window.innerHeight, this.scrollWrap.offsetHeight,this.scrollWrap.scrollHeight, this.scrollBox.offsetHeight,this.scrollBox.scrollHeight);
        //   1533 `3602` 892 1988 1988 490 516

        // const freezeThreshold = 2000; // 冻结阈值（额外保持固定的滚动距离）
        // const freezeStart = this.border_distance + positionY; // 冻结起始点
        // const freezeEnd = freezeStart + freezeThreshold; // 冻结结束点

        //  // 初始化冻结变量
        // if (!this.frozenDistanceX && scrollY > freezeStart && scrollY <= freezeEnd) {
        //     this.frozenDistanceX = -distance_x; // 保存冻结值
        // }
        
        if ( scrollPosition < positionY && scrollY <= (this.border_distance + positionY)) {
            // console.log('into-----', positionY);
            // this.scrollWrap.style.position = 'fixed';
            // this.scrollBox.style.transform = `translate3d(${-distance_x}px, 0px, 0px)`;
            // this.scrollBox.style.transition = 'transform 0.2s ease-out';

            this.scrollWrap.style.position = 'fixed';
            this.scrollBox.style.transform = `translate(${-distance_x}px, 0%) translate3d(0px, 0px, 0px)`;
            this.scrollBox.style.transition = 'transform 0.2s ease-out';

            // if (scrollY > freezeStart && scrollY <= freezeEnd) {
            //     // 进入冻结状态，保持 `fixed` 和当前 `transform` 值
            //     console.log('Frozen state active');
            //     this.scrollWrap.style.position = 'fixed';
            //     this.scrollBox.style.transform = `translate((${this.frozenDistanceX}px, 0%) translate3d(0px, 0px, 0px)`;
            //     this.scrollBox.style.transition = 'transform 0.2s ease-out';
            // } else {
            //     // 正常滚动逻辑
            //     console.log('into-----', positionY);
            //     this.scrollWrap.style.position = 'fixed';
            //     this.scrollBox.style.transform = `translate(${-distance_x}px, 0%) translate3d(0px, 0px, 0px)`;
            //     this.scrollBox.style.transition = 'transform 0.2s ease-out';

            //      // 重置冻结值
            //     if (scrollY <= freezeStart || scrollY > freezeEnd) {
            //         this.frozenDistanceX = null;
            //     }
            // }
        } else {
            if ( scrollPosition < positionY && scrollPositionBottom > 200) {
                this.scrollWrap.style.position = 'fixed';
            }else {
                this.scrollWrap.style.position = 'absolute';   
            }
        }
    }
};

// 注册自定义元素
if (!window.customElements.get('scroll-grid')) {
    window.customElements.define('scroll-grid', ScrollGrid);
}

// js/sections/zoom-out-in.js
var ZoomOutIn = class extends HTMLElement {
    constructor() {
        super();

        this.sectionID = null;
        this.scrollSpeed = 0.5;
        this.disableZoom = false;

        this._scrollTrigger = null;
        this._mode = null; // 'desktop' | 'mobile'
    }

    connectedCallback() {
        const header = document.querySelector('header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;

        this.sectionID = this.getAttribute('section-id');
        this.scrollSpeed = parseFloat(this.getAttribute('data-zoom-speed')) || 0.5;
        this.disableZoom = this.getAttribute('data-disable-zoom') === 'true';

        this.zoomOuter = document.getElementById(`zoom-out-in__outer-${this.sectionID}`);
        this.zoomOutIn = document.getElementById(`zoom-out-in-${this.sectionID}`);
        this.zoomWrap = document.getElementById(`zoom-out-in__wrap-${this.sectionID}`);

        this.zoomTextWrap = document.getElementById(`font-box-${this.sectionID}`);
        this.zoomTextList = document.querySelectorAll(`.zoom-out-in__text-${this.sectionID}`);
        this.zoomFollowTextList = document.querySelectorAll(`.zoom-out-in__follow_text-${this.sectionID}`);
        this.fontBox = this.closest('.outer-container')?.querySelector('.font-box');

        if (!this.zoomOuter || !this.zoomWrap) return;

        this.zoomOutIn.style.paddingTop = headerHeight + 'px';

        if (window.innerWidth <= 700) {
            this._mode = 'mobile';
            setTimeout(() => {
              this.initZoomOutInMobile();
            }, 2000);
        } else {
            this._mode = 'desktop';
            setTimeout(() => {
              this.initZoomOutInDesktop();
            }, 2000);
        }

        this._bindBreakpointReload();
    }

    disconnectedCallback() {
        this._scrollTrigger?.kill();
        this._scrollTrigger = null;
    }

    /* ===============================
       Desktop
    =============================== */

    initZoomOutInDesktop() {
        const scaleMax = 2;
        const scaleAutoStartRatio = 0.8;

        this.zoomWrap.style.opacity = 0;
        this.zoomWrap.style.transform = 'translateY(0px) scale(1) translateZ(0px)';

        this._scrollTrigger = ScrollTrigger.create({
            trigger: this.zoomOuter,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
            onUpdate: () => {
                const rect = this.zoomOuter.getBoundingClientRect();
                if (rect.bottom <= 0 || rect.top >= innerHeight) return;

                const scrollPosition = innerHeight - rect.top;

                let translateY = Math.min(100, scrollPosition * this.scrollSpeed * 0.5);
                translateY = Math.max(0, translateY);

                let scale = 1;
                if (!this.disableZoom) {
                    const progress = Math.min(scrollPosition / 1000, 1);
                    scale =
                        progress < scaleAutoStartRatio
                            ? 1 + (progress / scaleAutoStartRatio) * (scaleMax - 1)
                            : scaleMax;
                }

                const opacity = Math.min(1, scrollPosition / 1000);

                this.zoomWrap.style.opacity = opacity;
                this.zoomWrap.style.transform =
                    `translateY(${translateY}px) scale(${scale}) translateZ(0px)`;

                // ✅ Desktop 文案
                this._handleText(scrollPosition, 'desktop');
            }
        });
    }

    /* ===============================
       Mobile
    =============================== */

    initZoomOutInMobile() {
        this.zoomWrap.style.opacity = 0.5;
        this.zoomWrap.style.transform = 'translateZ(40px)';

        this._scrollTrigger = ScrollTrigger.create({
            trigger: this.zoomOuter,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
            onUpdate: () => {
                const rect = this.zoomOuter.getBoundingClientRect();
                if (rect.bottom <= 0 || rect.top >= innerHeight) return;

                const scrollPosition = innerHeight - rect.top;

                // 图片只做淡入
                const opacity = Math.min(1, 0.5 + scrollPosition / 600);
                this.zoomWrap.style.opacity = opacity;

                // ✅ Mobile 文案（简化版）
                this._handleText(scrollPosition, 'mobile');
            }
        });
    }

    /* ===============================
       Text Logic（核心修复）
    =============================== */

    _handleText(scrollPosition, mode) {
        if (!this.zoomTextWrap) return;

        const rect = this.zoomTextWrap.getBoundingClientRect();
        const isAtTop = rect.top <= 1;

        this.zoomTextList.forEach((item) => {
            if (mode === 'mobile') {
                item.style.opacity = isAtTop ? 1 : 0;
            } else {
                item.style.opacity = isAtTop && scrollPosition > 300 ? 1 : 0;
            }
        });

        this.zoomFollowTextList.forEach((item) => {
            if (mode === 'mobile') {
                item.style.opacity = isAtTop ? 1 : 0;
            } else {
                item.style.opacity = isAtTop
                    ? Math.min(1, scrollPosition / 100)
                    : 0;
            }
        });

        if (this.fontBox && isAtTop) {
            let opacityBox = 1;
            if (scrollPosition > innerHeight) {
                opacityBox =
                    1 -
                    (scrollPosition - innerHeight) /
                        (innerHeight * 0.5);
            }
            this.fontBox.style.setProperty('--before-opacity', opacityBox);
        }
    }

    /* ===============================
       Breakpoint Reload
    =============================== */

    _bindBreakpointReload() {
        let lastIsMobile = window.innerWidth <= 700;

        window.addEventListener('resize', () => {
            const isMobile = window.innerWidth <= 700;
            if (isMobile !== lastIsMobile) {
                location.reload();
            }
        });
    }
};

if (!window.customElements.get('zoom-out-in')) {
    window.customElements.define('zoom-out-in', ZoomOutIn);
}

// js/sections/media-with-text.js
import { animate as animate5, timeline as timeline7, inView as inView6 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { imageLoaded as imageLoaded2 } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var MediaWithText = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      Array.from(this.querySelectorAll(".media-with-text__item")).forEach((item) => {
        inView6(item, (observer) => this.reveal(observer.target));
      });
    }
  }
  reveal(item) {
    const media = item.querySelector(".media-with-text__media");
    const mediaAsset = media.querySelector("img, video-media, iframe, video, svg");
    const enableMediaFadeUp = item.dataset.enableMediaFadeUp === "true";
    const revealMedia = () => {
      if (enableMediaFadeUp) {
        timeline7([
          [media, { opacity: [0, 1], transform: ["translateY(40px)", "translateY(0)"] }, { duration: 0.5, easing: [0.42, 0, 0.58, 1] }]
        ]);
        return;
      }
      timeline7([
        [media, { opacity: [0, 1] }, { duration: 0.3 }],
        [media.querySelector("img, video-media, iframe, video, svg"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
      ]);
    };
    if (mediaAsset && mediaAsset.tagName === "IMG") {
      imageLoaded2(mediaAsset).then(revealMedia);
    } else {
      revealMedia();
    }
    animate5(item.querySelector(".media-with-text__content > .prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.3 });
  }
};
if (!window.customElements.get("media-with-text")) {
  window.customElements.define("media-with-text", MediaWithText);
}

// wlz custom medai show
var CMedai = class extends HTMLElement {
    connectedCallback() {
        if (reduceMotion) {
            Array.from(this.querySelectorAll(":scope > *")).forEach((item) => {
                inView6(item, (observer) => this.reveal(observer.target));
            });
        }
    }

    reveal(item) {
        const media = item.querySelector("img");
        imageLoaded2(media).then(() => {
            timeline7([
                [media, {opacity: [0, 1]}, {duration: 0.3}],
                [media, {transform: ["scale(1.05)", "scale(1)"]}, {
                    duration: 0.3,
                    at: "<"
                }]
            ]);
        });
        const textDiv = item.querySelector(":scope .prose")
        if(textDiv){
            animate5(textDiv, 
                {
                    opacity: [0, 1],
                    transform: ["translateY(30px)", "translateY(0)"]
                }, {
                duration: 0.3,
                delay: 0.5
            });
        }
    }
};
if (!window.customElements.get("c-medai")) {
    window.customElements.define("c-medai", CMedai);
}


// js/sections/multiple-images-with-text.js
import { timeline as timeline8, animate as animate6, stagger as stagger2, inView as inView7 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { EffectCarousel as EffectCarousel3, imageLoaded as imageLoaded3, getHeadingKeyframe as getHeadingKeyframe3 } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var MultipleImagesWithText = class extends HTMLElement {
  constructor() {
    super();
    this._imageCarousel = this.querySelector("multiple-images-with-text-image-list");
    this._contentCarousel = this.querySelector("multiple-images-with-text-content-list");
    this.addEventListener("control:prev", () => {
      this._imageCarousel.previous();
      this._contentCarousel.previous();
    });
    this.addEventListener("control:next", () => {
      this._imageCarousel.next();
      this._contentCarousel.next();
    });
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        if (event.target.hasAttribute("image-id")) {
          this._imageCarousel.select(this._imageCarousel.items.findIndex((item) => item.id === event.target.getAttribute("image-id")));
        }
      });
    }
  }
};
var MultipleImagesWithTextImageList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  async _reveal() {
    await imageLoaded3(this.querySelectorAll("img"));
    if (this.getAttribute("layout") === "stacked") {
      timeline8([
        [this.lastElementChild, { transform: "rotate(0deg)" }],
        [this.lastElementChild?.previousElementSibling, { transform: "rotate(2deg)" }, { at: "<" }],
        [this.lastElementChild?.previousElementSibling?.previousElementSibling, { transform: "rotate(-2deg)" }, { at: "<" }]
      ], {
        defaultOptions: { duration: 0.15, easing: [0.26, 0.02, 0.27, 0.97] }
      });
    } else if (this.getAttribute("layout") === "collage") {
      timeline8([
        [this.children, { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.3, delay: stagger2(0.1) }]
      ]);
    } else {
      timeline8([
        [this.children, { opacity: 1, transform: "rotate(var(--image-rotation, 0deg))" }, { duration: 0.3, delay: stagger2(0.1) }]
      ]);
    }
  }
  _transitionTo(fromSlide, toSlide, { direction, animate: animate8 }) {
    if (this.getAttribute("layout") !== "stacked") {
      return;
    }
    const transitionSpeed = 0.2;
    if (direction === "next") {
      const fromSlideTransform = getComputedStyle(fromSlide).getPropertyValue("transform");
      return timeline8([
        [fromSlide, { opacity: 0, transform: "rotate(5deg) translate(40px, 10px)" }, { duration: transitionSpeed }],
        [toSlide, { zIndex: 1 }, { duration: transitionSpeed, zIndex: { easing: "step-start" } }],
        [fromSlide, { opacity: 1, transform: fromSlideTransform, zIndex: -1 }, { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } }],
        [toSlide.previousElementSibling, { zIndex: 0 }, { at: "<", easing: "step-start" }]
      ], { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }).finished;
    } else {
      const toSlideTransform = getComputedStyle(toSlide).getPropertyValue("transform");
      return timeline8([
        [toSlide, { opacity: 0, transform: "rotate(-5deg) translate(-40px, -10px)" }, { duration: transitionSpeed }],
        this.items.length >= 3 && [fromSlide.previousElementSibling || this.lastElementChild, { zIndex: -1 }, { easing: "step-start" }],
        [toSlide, { opacity: 1, transform: toSlideTransform, zIndex: 1 }, { duration: transitionSpeed, at: this.items.length >= 3 ? "<" : "+0", zIndex: { easing: "step-start" } }],
        [fromSlide, { zIndex: 0 }, { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } }]
      ].filter(Boolean), { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }).finished;
    }
  }
};
var MultipleImagesWithTextContentList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  _reveal() {
    animate6(...getHeadingKeyframe3(this.querySelector('[reveal-on-scroll="true"]')));
  }
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate8 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    return timeline8([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }],
      [...getHeadingKeyframe3(toSlide.querySelector('[reveal-on-scroll="true"]'), { at: "<" })]
    ], { duration: animate8 ? parseFloat(this.getAttribute("fade-speed") || 0.5) : 0 }).finished;
  }
};
if (!window.customElements.get("multiple-images-with-text")) {
  window.customElements.define("multiple-images-with-text", MultipleImagesWithText);
}
if (!window.customElements.get("multiple-images-with-text-image-list")) {
  window.customElements.define("multiple-images-with-text-image-list", MultipleImagesWithTextImageList);
}
if (!window.customElements.get("multiple-images-with-text-content-list")) {
  window.customElements.define("multiple-images-with-text-content-list", MultipleImagesWithTextContentList);
}

// js/sections/newsletter-popup.js
import { Drawer as Drawer2 } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var NewsletterPopup = class extends Drawer2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get initialFocus() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppearAutomatically() {
    return !(localStorage.getItem("theme:popup-filled") === "true" || this.hasAttribute("only-once") && localStorage.getItem("theme:popup-appeared") === "true");
  }
  _setInitialPosition() {
    this.style.top = null;
    this.style.bottom = "0px";
    this.style.left = document.dir === "ltr" ? null : "0px";
    this.style.right = document.dir === "rtl" ? "auto" : "0px";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("newsletter-popup")) {
  window.customElements.define("newsletter-popup", NewsletterPopup);
}

// js/sections/press.js
import { timeline as timeline9, animate as animate7, inView as inView8 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { EffectCarousel as EffectCarousel4 } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var reduceMotion2 = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var PressCarousel = class extends EffectCarousel4 {
  constructor() {
    super();
    if (reduceMotion2) {
      inView8(this, this._reveal.bind(this));
    }
  }
  _reveal() {
    animate7(this.selectedSlide.querySelector(".blockquote"), { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.2 });
  }
  async _transitionTo(fromSlide, toSlide, options = {}) {
    await timeline9([
      [fromSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [null, 0] }, { duration: 0.2 }],
      [fromSlide.querySelector(".blockquote"), { opacity: [null, 0], ...reduceMotion2 && { transform: [null, "translateY(-10px)"] } }, { duration: 0.2, at: "<" }]
    ]).finished;
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    await timeline9([
      [toSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [0, 1] }, { duration: 0.2 }],
      [toSlide.querySelector(".blockquote"), { opacity: [0, 1], ...reduceMotion2 && { transform: ["translateY(10px)", "translateY(0px)"] } }, { duration: 0.2, at: "<" }]
    ]).finished;
  }
};
if (!window.customElements.get("press-carousel")) {
  window.customElements.define("press-carousel", PressCarousel);
}

// js/sections/product-recommendations.js
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }
  connectedCallback() {
    this._loadRecommendations();
  }
  async _loadRecommendations() {
    if (this._isLoaded) {
      return;
    }
    this._isLoaded = true;
    const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${section.id.replace("shopify-section-", "")}&intent=${intent}`, response = await fetch(url, { priority: "low" });
    // A section can hold several recommendation blocks (e.g. two Complementary products blocks): match this block's own
    // element in the response instead of the first one. Elements without data-block-id keep the first-match behavior.
    const blockId = this.getAttribute("data-block-id");
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = blockId ? tempDiv.querySelector(`product-recommendations[data-block-id="${CSS.escape(blockId)}"]`) : tempDiv.querySelector("product-recommendations");
    if (!productRecommendationsElement) {
      return;
    }
    if (productRecommendationsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
    } else {
      if (intent === "related") {
        section.remove();
      } else {
        this.remove();
      }
    }
  }
};
if (!window.customElements.get("product-recommendations")) {
  window.customElements.define("product-recommendations", ProductRecommendations);
}

var CustomProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this._onCartChangedListener = this._onCartChanged.bind(this);
  }
  connectedCallback() {
    document.addEventListener("cart:change", this._onCartChangedListener);
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  async _onCartChanged(event) {

    const section = this.closest(".shopify-section");
    // https://us.mammotion.com/?section_id=sections--23222761652522__cart-drawer
    const url = `${Shopify.routes.root}?&section_id=${section.id.replace("shopify-section-", "")}`;
    const response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html")
    const productRecommendationsElement = tempDiv.querySelector("custom-product-recommendations");
    const productRecommendationsList = productRecommendationsElement?.querySelector(".horizontal-product-list")

    if (productRecommendationsList && productRecommendationsList?.childElementCount > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
    } else {
      // 为空，需要隐藏
      this.remove();
    }
  }
};
if (!window.customElements.get("custom-product-recommendations")) {
  window.customElements.define("custom-product-recommendations", CustomProductRecommendations);
}

// js/sections/recently-viewed-products.js
import { extractSectionId } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var _isLoaded, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _searchQueryString);
    __privateAdd(this, _loadProducts);
    __privateAdd(this, _isLoaded, false);
  }
  connectedCallback() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(__privateMethod(this, _loadProducts, loadProducts_fn).bind(this), { timeout: 1500 });
    } else {
      __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
    }
  }
};
_isLoaded = new WeakMap();
_searchQueryString = new WeakSet();
searchQueryString_get = function() {
  const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
  if (this.hasAttribute("exclude-id")) {
    items.delete(parseInt(this.getAttribute("exclude-id")));
  }
  return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
};
_loadProducts = new WeakSet();
loadProducts_fn = async function() {
  if (__privateGet(this, _isLoaded)) {
    return;
  }
  __privateSet(this, _isLoaded, true);
  const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
  if (recentlyViewedProductsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
  } else {
    section.remove();
  }
};
if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

// js/sections/revealed-image-on-scroll.js
import { scroll as scroll3, timeline as timeline10, ScrollOffset, inView as inView9 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
var RevealedImage = class extends HTMLElement {
  connectedCallback() {
    const scrollTracker = this.querySelector(".revealed-image__scroll-tracker"), scroller = this.querySelector(".revealed-image__scroller");
    scrollTracker.style.height = `${scroller.clientHeight}px`;
    new ResizeObserver((entries) => scrollTracker.style.height = `${entries[0].contentRect.height}px`).observe(scroller);
    scroll3(timeline10([
      [this.querySelectorAll(".revealed-image__image-clipper, .revealed-image__content--inside"), { clipPath: ["inset(37% 37% 41% 37%)", "inset(calc(var(--sticky-area-height) / 2) 0)"] }, { easing: "ease-in" }],
      [this.querySelectorAll("img, svg"), { transform: ["translate(-10%, -1.5%) scale(1.4)", "translate(0, 0) scale(1)"] }, { easing: "ease-in", at: "<" }],
      [this.querySelectorAll(".revealed-image__content"), { opacity: [0, 1, 1] }, { offset: [0, 0.25, 1], at: "<" }]
    ]), {
      target: scrollTracker,
      offset: ScrollOffset.All
    });
    inView9(this, () => {
      this.style.visibility = "visible";
      return () => {
        this.style.visibility = "hidden";
      };
    }, { margin: "200px" });
  }
};
if (!window.customElements.get("revealed-image")) {
  window.customElements.define("revealed-image", RevealedImage);
}

// js/sections/shop-the-look.js
var ShopTheLookDots = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    Array.from(this.children).forEach((dots) => {
      document.getElementById(dots.getAttribute("aria-controls")).addEventListener("carousel:change", (event) => this._onDotClicked(event), { signal: this._abortController.signal });
    });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  _onDotClicked(event) {
    Array.from(this.querySelectorAll(`button:nth-child(${event.detail.index + 1})`)).forEach((button) => button.click());
  }
};
if (!window.customElements.get("shop-the-look-dots")) {
  window.customElements.define("shop-the-look-dots", ShopTheLookDots);
}

// js/sections/slideshow.js
import { animate as motionAnimate2, timeline as timeline11, inView as inView10 } from "//au.mammotion.com/cdn/shop/t/27/assets/vendor.min.js?v=136053555471622566971766139691";
import { EffectCarousel as EffectCarousel5, imageLoaded as imageLoaded4, getHeadingKeyframe as getHeadingKeyframe4 } from "//au.mammotion.com/cdn/shop/t/27/assets/theme.js?v=160067281823607520171793774456";
var Slideshow = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("carousel:select", this._onSlideSelected);
  }
  async _onSlideSelected(event) {
    const slideStyles = getComputedStyle(event.detail.slide);
    this.style.setProperty("--slideshow-controls-background", slideStyles.getPropertyValue("--slideshow-slide-controls-background"));
    this.style.setProperty("--slideshow-controls-color", slideStyles.getPropertyValue("--slideshow-slide-controls-color"));
    if (!this.classList.contains("slideshow--boxed")) {
      return;
    }
    const backgroundElement = this.querySelector(".slideshow__slide-background");
    const background = slideStyles.getPropertyValue("--slideshow-slide-background");
    backgroundElement.style.background = background;
    await motionAnimate2(backgroundElement, { opacity: [0, 1] }, { duration: 0.2 }).finished;
    this.style.setProperty("--slideshow-background", background);
    motionAnimate2(backgroundElement, { opacity: 0 }, { duration: 0 });
  }
};
var SlideshowCarousel = class extends EffectCarousel5 {
  constructor() {
    super();
    inView10(this, this._reveal.bind(this));
    if (this.querySelector(".slideshow__cursor")) {
      this.addEventListener("tap", this._onSlideshowTap.bind(this));
    }
  }
  connectedCallback() {
    this._prepareSlideshowV2Slides();
    this._mountSlideshowV2FixedBadges();
    this._ensureSlideshowV2Pagination();
    super.connectedCallback();
    this._eagerLoadFirstSlideMedia();
    this._syncSlideshowV2Badges();
    this._syncSlideshowV2SideArrows();
    this.addEventListener("carousel:select", this._syncSlideshowV2Badges.bind(this), { signal: this._abortController.signal });
    this.addEventListener("carousel:select", this._syncSlideshowV2SideArrows.bind(this), { signal: this._abortController.signal });
    if (this._player && this.hasAttribute("autoplay")) {
      this._player.addEventListener("player:start", () => {
        const cursorRing = this.querySelector(".slideshow__cursor-ring circle");
        if (cursorRing) {
          motionAnimate2(cursorRing, { strokeDasharray: [`0px, ${cursorRing.getTotalLength()}px`, `${cursorRing.getTotalLength()}px, ${cursorRing.getTotalLength()}px`] }, {
            duration: parseInt(this.getAttribute("autoplay")),
            easing: "linear"
          });
        }
        const circles = Array.from(this.querySelectorAll(".numbered-dots__item"));
        circles.forEach((item) => {
          const circle = item.querySelector("circle:last-child");
          if (item.getAttribute("aria-current") === "true") {
            motionAnimate2(circle, { strokeDasharray: [`0px, ${circle.getTotalLength()}px`, `${circle.getTotalLength()}px, ${circle.getTotalLength()}px`] }, { duration: parseInt(this.getAttribute("autoplay")), easing: "linear" });
          } else {
            motionAnimate2(circle, { strokeDasharray: `${circle.getTotalLength()}px, ${circle.getTotalLength()}px` }, { duration: 0, easing: "linear" });
          }
        });
      });
    }
  }
  get transitionType() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "fade" : this.getAttribute("transition");
  }
  /**
   * Entrance animation sets inline opacity on buttons; remove it so CSS hover opacity works.
   * Also clear leftover transform/opacity on controls — Motion leaves inline transform
   * that would otherwise fight CSS positioning (e.g. centered pagination).
   */
  _clearSlideButtonOpacity(slide) {
    slide?.querySelectorAll(".button").forEach((button) => {
      button.style.removeProperty("opacity");
    });
    const controls = this.querySelector(".slideshow__controls, .slideshow-v2__controls");
    if (controls) {
      controls.style.removeProperty("transform");
      controls.style.removeProperty("opacity");
    }
  }
  async _reveal() {
    const selectedSlide = this.selectedSlide;
    await imageLoaded4(selectedSlide.querySelectorAll("img"));
    this.style.opacity = "1";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    if (!this._reloaded) {
      const revealTimeline = timeline11([
        [selectedSlide, { zIndex: 1 }, { duration: 0 }],
        [selectedSlide.querySelectorAll("img"), { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3 }],
        "content",
        [selectedSlide.querySelectorAll('[data-sequence="subheading"], .button'), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
        [...getHeadingKeyframe4(selectedSlide.querySelector('[data-sequence="heading"]'), { duration: 0.3, at: "content" })],
        [this.querySelector(".slideshow__controls, .slideshow-v2__controls"), { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }]
      ]);
      revealTimeline.finished.then(() => this._clearSlideButtonOpacity(selectedSlide));
    }
  }
  _onSlideshowTap(event) {
    const clickedElement = event.detail.originalEvent.target || event.target;

        if (clickedElement.tagName === 'INPUT') {
            return;
        }
       if (event.target.matches("button, a[href], button :scope, a[href] :scope, input, form") || !window.matchMedia("screen and (pointer: fine)").matches) {
            return;
        }
        event.detail.originalEvent.clientX > window.innerWidth / 2 ? this.next() : this.previous();
  }
  /**
   * Perform a simple fade animation. For more complex animations, you should implement your own custom elements
   * that extends the EffectCarousel, and implement your own transition. You should make sure to return a promise
   * that resolves when the animation is finished
   */
  async _transitionTo(fromSlide, toSlide, { direction, animate: animate8 = true } = {}) {
    if (this.transitionType === "content_fade" && this.classList.contains("slideshow-v2__carousel")) {
      fromSlide.classList.add("is-leaving");
      toSlide.style.opacity = "0";
      toSlide.style.visibility = "hidden";
    }
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let timelineControls = null;
    switch (this.transitionType) {
      case "fade":
        timelineControls = this._fade(fromSlide, toSlide, { animate: animate8 });
        break;
      case "fade_with_text":
        timelineControls = this._fadeWithText(fromSlide, toSlide, { animate: animate8 });
        break;
      case "content_fade":
        timelineControls = this._contentFade(fromSlide, toSlide, { animate: animate8 });
        break;
    }
    if (!timelineControls) {
      timelineControls = this._fade(fromSlide, toSlide, { animate: animate8 });
    }
    if (!animate8) {
      timelineControls.finish();
    }
    return timelineControls.finished;
  }
  /**
   * Read a spacing token in px from the element, with a numeric fallback.
   * @param {Element} element
   * @param {string} tokenName
   * @param {number} fallback
   * @returns {number}
   */
  _readSpaceTokenPx(element, tokenName, fallback) {
    const raw = getComputedStyle(element).getPropertyValue(tokenName).trim();
    const value = Number.parseFloat(raw);
    return Number.isFinite(value) ? value : fallback;
  }
  /**
   * Visible content rows inside a banner, skipping spacers so the unfold
   * originates from the first real line rather than empty gap blocks.
   * @param {Element} content
   * @returns {HTMLElement[]}
   */
  _getSlideshowV2ContentItems(content) {
    return Array.from(content.children).filter((el) => {
      if (el.classList.contains("shopify-block__spacer")) return false;
      const style = getComputedStyle(el);
      return style.display !== "none" && el.offsetHeight > 0;
    });
  }
  /**
   * Slideshow v2 default transition:
   * Image swap copies the original slideshow `_fade` (300ms crossfade,
   * ease-in out / ease-out in). Incoming content rows stay hidden and
   * still unfold after the images settle.
   */
  _contentFade(fromSlide, toSlide) {
    const contentEase = [0.22, 1, 0.36, 1];
    const fromMedia = fromSlide.querySelector(".banner-item__media");
    const fromContent = fromSlide.querySelector(".banner-item__content");
    const toMedia = toSlide.querySelector(".banner-item__media");
    const toContent = toSlide.querySelector(".banner-item__content");
    if (!fromMedia || !fromContent || !toMedia || !toContent) {
      fromSlide.classList.remove("is-leaving");
      return this._fade(fromSlide, toSlide);
    }
    const contentItems = this._getSlideshowV2ContentItems(toContent);
    const shiftCap = this._readSpaceTokenPx(toContent, "--space-token-l", 24);
    const firstTop = contentItems[0]?.offsetTop ?? 0;
    const itemFromY = contentItems.map((el, index) => {
      if (index === 0) return 0;
      return Math.max(firstTop - el.offsetTop, -shiftCap);
    });
    fromSlide.classList.add("is-leaving");
    toContent.style.opacity = "1";
    contentItems.forEach((el, index) => {
      el.style.opacity = "0";
      el.style.transform = `translateY(${itemFromY[index]}px)`;
    });
    const sequence = [
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { duration: 0.3, at: "<", easing: "ease-out", zIndex: { easing: "step-end" } }]
    ];
    if (contentItems.length === 0) {
      toContent.style.opacity = "0";
      sequence.push([toContent, { opacity: [0, 1] }, { duration: 0.4, easing: contentEase, at: 0.4 }]);
    } else {
      contentItems.forEach((el, index) => {
        sequence.push([
          el,
          { opacity: [0, 1], transform: [`translateY(${itemFromY[index]}px)`, "translateY(0px)"] },
          { duration: 0.4, easing: contentEase, at: 0.4 + index * 0.04 }
        ]);
      });
    }
    const timelineControls = timeline11(sequence);
    timelineControls.finished.then(() => {
      fromSlide.classList.remove("is-leaving");
      [fromSlide, toSlide].forEach((slide) => {
        slide.style.removeProperty("opacity");
        slide.style.removeProperty("visibility");
        slide.style.removeProperty("z-index");
      });
      toContent.style.removeProperty("opacity");
      contentItems.forEach((el) => {
        el.style.removeProperty("opacity");
        el.style.removeProperty("transform");
      });
      this._clearSlideButtonOpacity(toSlide);
    });
    return timelineControls;
  }
  /**
   * Add theme slideshow slide classes onto v2 banner blocks for shared CSS.
   */
  _prepareSlideshowV2Slides() {
    if (!this.classList.contains("slideshow-v2__carousel")) return;
    let banners = Array.from(this.querySelectorAll(":scope > .shopify-block__banner-item"));
    if (banners.length === 0) {
      banners = Array.from(this.querySelectorAll(".shopify-block__banner-item")).filter(
        (el) => !el.parentElement?.closest(".shopify-block__banner-item")
      );
    }
    banners.forEach((el, index) => {
      el.classList.add("slideshow__slide");
      el.setAttribute("data-slide-index", String(index + 1));
      if (index === 0) el.classList.add("is-selected");
    });
    this.closest(".slideshow-v2")?.classList.toggle("slideshow-v2--multiple", banners.length > 1);
    this._syncSlideshowV2NavVisibility(banners.length);
    this._syncSlideshowV2SideArrows();
  }
  /**
   * Hide cursor / side arrows when there is only one banner.
   * Liquid slide_count is unreliable for theme blocks, so this runs from the real DOM.
   * @param {number} slideCount
   */
  _syncSlideshowV2NavVisibility(slideCount) {
    const isMultiple = slideCount > 1;
    const cursor = this.querySelector(":scope > .slideshow__cursor");
    if (cursor) cursor.toggleAttribute("hidden", !isMultiple);
    const sideButtons = this.querySelector(".prev-next-btn");
    if (sideButtons) sideButtons.toggleAttribute("hidden", !isMultiple);
    const navArrows = this.querySelector(":scope > .slideshow-v2__nav-arrows");
    if (navArrows) navArrows.toggleAttribute("hidden", !isMultiple);
  }
  /**
   * mouse_arrow_sides controls start as carousel siblings (above every slide).
   * Banner copy lives inside .banner-item, so its z-index cannot paint above those
   * siblings. Re-host the arrow chrome inside the selected .banner-item so media,
   * frosted arrows, and copy share one stacking context:
   * media < arrows < copy.
   * @param {CustomEvent} [event]
   */
  _syncSlideshowV2SideArrows(event) {
    if (!this.classList.contains("slideshow-v2__carousel")) return;
    const sideButtons = this.querySelector(".prev-next-btn");
    if (!sideButtons) return;
    const selected = event?.detail?.slide
      || this.selectedSlide
      || this.querySelector(".slideshow__slide.is-selected");
    if (!selected) return;
    const host = selected.matches(".banner-item")
      ? selected
      : selected.querySelector(".banner-item") || selected;
    if (sideButtons.parentElement !== host) {
      host.appendChild(sideButtons);
    }
  }
  /**
   * Theme-block sections may report slide_count=0 in Liquid. Build or repair
   * page-dots from the actual banner slides so pagination is visible.
   */
  _ensureSlideshowV2Pagination() {
    if (!this.classList.contains("slideshow-v2__carousel")) return;
    const slides = this.querySelectorAll(".slideshow__slide");
    const controls = this.querySelector(":scope > .slideshow-v2__controls");
    if (!controls) return;
    if (slides.length <= 1) {
      controls.hidden = true;
      return;
    }
    controls.hidden = false;
    const pagination = controls.getAttribute("data-pagination") || "none";
    if (pagination === "none") return;
    const dots = controls.querySelector("page-dots");
    if (!dots) return;
    if (dots.children.length === slides.length) return;
    const autoplay = controls.getAttribute("data-autoplay") === "true";
    const cycleSpeed = controls.getAttribute("data-cycle-speed") || "6";
    dots.replaceChildren();
    for (let index = 0; index < slides.length; index += 1) {
      dots.appendChild(this._createSlideshowV2DotButton(pagination, index, slides.length, autoplay, cycleSpeed));
    }
    dots.items = Array.from(dots.children);
    if (dots._abortController) {
      dots.items.forEach((button, index) => {
        button.addEventListener("click", () => dots.select(index), { signal: dots._abortController.signal });
      });
    }
  }
  /**
   * @param {string} pagination
   * @param {number} index
   * @param {number} total
   * @param {boolean} autoplay
   * @param {string} cycleSpeed
   * @returns {HTMLButtonElement}
   */
  _createSlideshowV2DotButton(pagination, index, total, autoplay, cycleSpeed) {
    const button = document.createElement("button");
    button.type = "button";
    button.setAttribute("aria-current", index === 0 ? "true" : "false");
    const label = document.createElement("span");
    label.className = "sr-only";
    label.textContent = `${index + 1} / ${total}`;
    if (pagination === "numbers") {
      button.className = "numbered-dots__item";
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "100%");
      svg.setAttribute("height", "100%");
      if (autoplay) svg.style.setProperty("--percent", "0");
      for (let i = 0; i < 2; i += 1) {
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", "50%");
        circle.setAttribute("cy", "50%");
        circle.setAttribute("r", "15");
        svg.appendChild(circle);
      }
      const number = document.createElement("span");
      number.textContent = String(index + 1);
      button.append(svg, number);
    } else if (pagination === "progress_dots") {
      button.className = "progress-btn";
      button.style.setProperty("--progress-duration", `${cycleSpeed}s`);
      const bar = document.createElement("div");
      bar.className = "progress-bar";
      const fill = document.createElement("div");
      fill.className = "progress-fill";
      bar.appendChild(fill);
      const dot = document.createElement("div");
      dot.className = "progress-dot";
      button.append(label, bar, dot);
    } else {
      button.className = "tap-area";
      button.appendChild(label);
    }
    return button;
  }
  _eagerLoadFirstSlideMedia() {
    const firstSlide = this.querySelector('.slideshow__slide[data-slide-index="1"]');
    if (!firstSlide) return;
    firstSlide.querySelectorAll("img, video").forEach((media) => {
      media.setAttribute("loading", "eager");
      media.setAttribute("fetchpriority", "high");
    });
  }
  /**
   * Move direct fixed-mode badges into the slideshow stack, in editor order.
   * Nested badges stay inside their banner and keep positioned layout.
   * An empty stack is removed so the section does not keep a placeholder.
   */
  _mountSlideshowV2FixedBadges() {
    if (!this.classList.contains("slideshow-v2__carousel")) return;
    const fixedBadges = Array.from(this.querySelectorAll(":scope > .shopify-block__badge")).filter((wrap) => {
      const badge = wrap.matches(".badge-block") ? wrap : wrap.querySelector(":scope > .badge-block");
      return badge?.getAttribute("data-position-mode") === "fixed";
    });
    if (fixedBadges.length === 0) {
      this.querySelector(":scope > .slideshow-v2__badge-stack")?.remove();
      return;
    }
    let stack = this.querySelector(":scope > .slideshow-v2__badge-stack");
    if (!stack) {
      stack = document.createElement("div");
      stack.className = "slideshow-v2__badge-stack";
      this.appendChild(stack);
    }
    fixedBadges.forEach((wrap) => {
      stack.appendChild(wrap);
    });
  }
  /**
   * Section-level badges are siblings of banners, or children of the fixed stack.
   * Nested badges inside a banner are ignored here so their targeting settings do not apply.
   *
   * carousel:select fires before is-selected moves. Always prefer event.detail.slide
   * so targeting follows the incoming frame, not the one that is leaving.
   * @param {CustomEvent} [event]
   */
  _syncSlideshowV2Badges(event) {
    const wraps = this.querySelectorAll(":scope > .shopify-block__badge, :scope > .slideshow-v2__badge-stack > .shopify-block__badge");
    if (wraps.length === 0) return;
    const selected = event?.detail?.slide
      || this.selectedSlide
      || this.querySelector(":scope > .slideshow__slide.is-selected");
    const index = selected?.getAttribute("data-slide-index");
    wraps.forEach((wrap) => {
      const inner = wrap.querySelector(".badge-block");
      if (!inner) {
        wrap.hidden = true;
        return;
      }
      if (inner.getAttribute("data-apply-all") === "true") {
        wrap.hidden = false;
        return;
      }
      const targets = (inner.getAttribute("data-slide-targets") || "")
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
      wrap.hidden = !index || !targets.includes(index);
    });
  }
  /**
   * Perform a simple fade transition
   */
  _fade(fromSlide, toSlide) {
    return timeline11([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { duration: 0.3, at: "<", easing: "ease-out", zIndex: { easing: "step-end" } }]
    ]);
  }
  /**
   * Perform a transition with fade images and image transition
   */
  async _fadeWithText(fromSlide, toSlide) {
    motionAnimate2(fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } });
    await imageLoaded4(toSlide.querySelectorAll("img"));
    motionAnimate2(toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { duration: 0, zIndex: { easing: "step-end" } });
    const textTimeline = timeline11([
      [toSlide.querySelectorAll("img"), { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, easing: "ease-out" }],
      "content",
      [toSlide.querySelectorAll('[data-sequence="subheading"], .button'), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
      [...getHeadingKeyframe4(toSlide.querySelector('[data-sequence="heading"]'), { duration: 0.3, at: "content" })]
    ]);
    textTimeline.finished.then(() => this._clearSlideButtonOpacity(toSlide));
    return textTimeline;
  }
};
if (!window.customElements.get("x-slideshow")) {
  window.customElements.define("x-slideshow", Slideshow);
}
if (!window.customElements.get("slideshow-carousel")) {
  window.customElements.define("slideshow-carousel", SlideshowCarousel);
}


var ScrollTriggerTextWithImage = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute('sectionId')
  }

  connectedCallback() {
    setTimeout(() => {
      const SCREEN_HEIGHT = window.innerHeight;
      const SCREEN_WIDTH = window.innerWidth;
      const section = this.querySelector(`#ScrollTextWrapper-${this._id}`);
      const text = this.querySelector(`#TextWrapper-${this._id}`);
      const bg = this.querySelector(`#BGWrapper-${this._id}`);
      const bgText = this.querySelector(`#BGTextWrapper-${this._id}`);
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          pin: true,
          anticipatePin: 1,
          scrub: 1,
          pin: section,
          start: 'top top',
          end: '200%',
        },
      });

      tl.from(bg, {
          scale: 0,
          ease: 'power1.inOut',
        })
        .to(text, {
          scale: 5,
          ease: 'power1.in',
          backgroundPositionY: '25%',
          y: -150,
          duration: 1.5
        }, 0)
        .to(text, {
          opacity: 0,
          ease: 'power1.in'
        })
        .to(bg, {
          opacity: 1,
          ease: 'power1.out',
          filter: 'blur(0) contrast(1.05)',
          duration: 0.3
        }, 1)
        .to(bgText, {
          y: -100,
          ease: 'power1.out',
          opacity: 1,
          duration: 1,
          delay: 1
        }, 0);

    }, 1000);

  }
  disconnectedCallback() {

  }
}
if (!window.customElements.get("scroll-trigger-text-with-image")) {
  window.customElements.define("scroll-trigger-text-with-image", ScrollTriggerTextWithImage);
}

var ScrollTriggerImagesSequence = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute('sectionId');
    this._imageCount = this.getAttribute('imageCount');
    this._imageStartUrl = this.getAttribute('imageStartUrl');
    this._imageStartId = this.getAttribute('imageStartId');
    this._hasTip = this.hasAttribute('hasTip');
    this._wrapperHeight = parseInt(this.getAttribute('wrapperHeight')) || 300;
    this._scrollEndOffset = parseInt(this.getAttribute('scrollEndOffset')) || 50;
  }

  connectedCallback() {
    const _this = this;

    /* 等待 GSAP 和 ScrollTrigger 就绪 */
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      _this.initAnimation();
    } else {
      var checkReady = setInterval(function () {
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          clearInterval(checkReady);
          gsap.registerPlugin(ScrollTrigger);
          
          _this.initAnimation();
          // window.addEventListener('load', () => {
          //   ScrollTrigger.sort(); // 多个 ScrollTrigger 实例时，确保它们按正确的顺序执行
          //   ScrollTrigger.refresh(); // 刷新 ScrollTrigger 以确保正确计算滚动位置
          // });
        }
      }, 200);
    }

  }
  disconnectedCallback() {

  }

  initAnimation() {
    const _this = this;
    
    const SCREEN_HEIGHT = window.innerHeight;
    const SCREEN_WIDTH = window.innerWidth;
    const imagesWrapper = this.querySelector('.image-sequence-wrapper');
    const frameCount = this._imageCount;
    const canvas = this.querySelector(`#image-sequence-${this._id}`);

    const names = this._imageStartUrl.split(this._imageStartId);
    if (names.length != 2) {
      console.error('Invalid image start url or image start id');
      return false;
    }

    const progressItems = this.querySelectorAll('.image-sequence-content-item');
    const progressItemsWrapper = this.querySelector('.image-sequence-content-wrapper');
    const annotationSvg = this.querySelector('.progress-annotation-svg');

    const tipWrapper = this.querySelector('.tip-content-wrapper');

    const nameStart = names[0];
    const nameEnd = names[1];

    const urls = Array.from({
        length: frameCount
      }, (_, i) =>
      `${nameStart}${this.incrementString(this._imageStartId, i)}${nameEnd}`
    );

    // Initialize the image sequence
    imageSequence({
      urls,
      canvas: `#image-sequence-${this._id}`,
      scrollTrigger: {
        trigger: imagesWrapper,
        pin: true,
        pinSpacing: false,
        // markers: true, // for debugging
        start: 'top top',
        end: `+=${(this._wrapperHeight - this._scrollEndOffset) * SCREEN_HEIGHT / 100}`,
        scrub: true,
        onUpdate: (self) => {
          handleUpdate(self);
        },
      },
    });

    /**
     * Handles scrubbing through a sequence of images, drawing the appropriate one to the provided canvas.
     * @param {Object} config - Configuration object for the image sequence.
     */
    function imageSequence(config) {
      const canvas = gsap.utils.toArray(config.canvas)[0] || console.warn('canvas not defined');
      const ctx = canvas.getContext('2d');
      const images = config.urls.map(url => {
        const img = new Image();
        img.src = url;
        return img;
      });

      let playhead = {
        frame: 0
      };
      let curFrame = -1;

      const updateImage = () => {
        const frame = Math.round(playhead.frame);
        if (frame !== curFrame) {
          config.clear && ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(images[frame], 0, 0);
          curFrame = frame;
          config.onUpdate?.(frame, images[frame]); // Optional chaining
        }
      };

      images[0].onload = updateImage; // Call updateImage once the first image loads

      return gsap.to(playhead, {
        frame: images.length - 1,
        ease: 'none',
        onUpdate: updateImage,
        duration: images.length / (config.fps || 30),
        paused: !!config.paused,
        scrollTrigger: config.scrollTrigger,
      });
    }

    function parseNum(value, fallback = 0) {
      const n = parseFloat(value);
      return Number.isFinite(n) ? n : fallback;
    }

    function resolveOffset(value, base) {
      const n = parseNum(value, 0);
      return Math.abs(n) < 2 ? n * base : n;
    }

    function isMobileViewport() {
      return window.innerWidth <= 700;
    }

    function useMobileCustomPosition(item) {
      return isMobileViewport() && item.dataset.mobileCustomPositionEnabled === 'true';
    }

    function getProgressRange(item) {
      if (useMobileCustomPosition(item)) {
        return {
          start: parseNum(item.dataset.mobileProgressStart, parseNum(item.dataset.progressStart, 0)),
          end: parseNum(item.dataset.mobileProgressEnd, parseNum(item.dataset.progressEnd, 100)),
        };
      }

      return {
        start: parseNum(item.dataset.progressStart, 0),
        end: parseNum(item.dataset.progressEnd, 100),
      };
    }

    function applyProgressItemPositionMode(item) {
      const useMobilePosition = useMobileCustomPosition(item);
      const positionCss = useMobilePosition ? item.dataset.mobilePositionCss : item.dataset.desktopPositionCss;

      item.classList.toggle('mobile-custom-position-active', useMobilePosition);

      if (positionCss) {
        item.style.cssText = positionCss;
      } else {
        item.removeAttribute('style');
      }
    }

    function layoutProgressAnnotations() {
      if (!canvas || !annotationSvg) return;

      const canvasRect = canvas.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      annotationSvg.setAttribute('width', viewportWidth);
      annotationSvg.setAttribute('height', viewportHeight);
      annotationSvg.innerHTML = '';

      progressItems.forEach((item) => {
        if (item.dataset.annotationEnabled !== 'true' || !item.classList.contains('active') || useMobileCustomPosition(item)) return;

        const x = parseNum(item.dataset.anchorX, 0.5);
        const y = parseNum(item.dataset.anchorY, 0.5);
        const side = item.dataset.side || 'right';

        const px = canvasRect.left + x * canvasRect.width;
        const py = canvasRect.top + y * canvasRect.height;

        const dx = resolveOffset(item.dataset.offsetX, viewportWidth);
        const dy = resolveOffset(item.dataset.offsetY, viewportHeight);

        const labelX = px + dx;
        const labelY = py + dy;

        item.style.left = `${labelX}px`;
        item.style.top = `${labelY}px`;

        const dot = item.querySelector('.progress-dot');
        if (!dot) return;

        let dotRect = dot.getBoundingClientRect();
        let targetX = dotRect.left + dotRect.width / 2;
        let targetY = dotRect.top + dotRect.height / 2;

        if (item.dataset.horizontal === 'true') {
          const deltaY = py - targetY;
          item.style.top = `${labelY + deltaY}px`;

          dotRect = dot.getBoundingClientRect();
          targetX = dotRect.left + dotRect.width / 2;
          targetY = dotRect.top + dotRect.height / 2;
        }

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

        if (item.dataset.horizontal === 'true') {
          path.setAttribute('d', `M ${px} ${py} L ${targetX} ${targetY}`);
        } else {
          const kneeOffset = parseNum(item.dataset.kneeOffset, 28);
          const kneeX = side === 'right' ? targetX - kneeOffset : targetX + kneeOffset;

          path.setAttribute('d', `
            M ${px} ${py}
            L ${kneeX} ${targetY}
            L ${targetX} ${targetY}
          `);
        }

        path.setAttribute('stroke', 'rgba(255,255,255,0.6)');
        path.setAttribute('stroke-width', '1.2');
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke-linejoin', 'round');
        path.setAttribute('stroke-linecap', 'round');

        annotationSvg.appendChild(path);
      });
    }

    function handleUpdate(self) {
      const progress = self.progress * 100;
      if (progress > 1) {
        _this.style.opacity = 1;
      } else {
        _this.style.opacity = 0;
      }

      if (progress > 0 && progress < 100) {
        progressItemsWrapper.classList.add('active');
      } else {
        progressItemsWrapper.classList.remove('active');
      }
      console.log("imageSequence progress:", progress)
      progressItems.forEach((item, index) => {
        applyProgressItemPositionMode(item);

        // 如果是最后一个
        const isLast = index === progressItems.length - 1;
        const range = getProgressRange(item);

        if (progress >= range.start && progress <= range.end) {
          item.classList.add('active');
          if(_this._hasTip === "true") {
            if (isLast && tipWrapper) {
              // 最后一个需要特殊处理
              tipWrapper.classList.add('show');
            } else {
              tipWrapper.classList.remove('show');
            }
          }
        } else {
          item.classList.remove('active');
        }
      });
      layoutProgressAnnotations();
    }

    function handleResize() {
      progressItems.forEach((item) => {
        applyProgressItemPositionMode(item);
      });
      layoutProgressAnnotations();
    }

    progressItems.forEach((item) => {
      applyProgressItemPositionMode(item);
    });

    window.addEventListener('resize', handleResize);

  }

  incrementString(str, index) {
    // 将字符串转为数字，加1，再转回字符串
    const num = parseInt(str, 10);
    if (isNaN(num)) return str; // 如果不是数字，返回原字符串

    // 计算新数字
    const newNum = num + index;

    // 保持原字符串长度，不足补0
    const paddedStr = newNum.toString().padStart(str.length, '0');

    // 如果结果长度超过原字符串长度，返回完整数字
    return paddedStr.length > str.length ? newNum.toString() : paddedStr;
  }
}

if (!window.customElements.get("scroll-trigger-images-sequence")) {
  window.customElements.define("scroll-trigger-images-sequence", ScrollTriggerImagesSequence);
}

var ScrollTriggerOpenEyes = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute('sectionId');
    this._isVideo = this.getAttribute("isVideo") === 'true' ? true : false;
  }

  connectedCallback() {
    let _this = this;
    setTimeout(() => {
      const SCREEN_HEIGHT = window.innerHeight;
      const SCREEN_WIDTH = window.innerWidth;
      const IS_MOBILE = SCREEN_WIDTH <= 700 ? true : false;

      const section = this.closest(".shopify-section");
      const nextSection = section.nextElementSibling;



      // 一线天睁眼动画
      const titleWrapper = _this.querySelector(".title-wrapper");
      const playWrapper = _this.querySelector(".player-wrapper");
      const contentWrapper = _this.querySelector(".content-wrapper");
      const innerContent = _this.querySelector(".player-inner-content");
      const bottomContent = _this.querySelector(".player-media-bottom-content");

      var collapseTargets = [titleWrapper, contentWrapper].filter(Boolean);

      const eyeTl = gsap.timeline({
        scrollTrigger: {
          trigger: `#open-eyes-${this._id}`,
          pin: true,
          anticipatePin: 1,
          scrub: 1,
          start: 'top top',
          endTrigger: nextSection,
          end: "top bottom",
          snap: {
            snapTo: 'video',
            duration: { min: 2, max: 3 },
            delay: 0.2,
            ease: 'power1.inOut'
          }
        },
      });
      eyeTl.to(".open-eyes-wrapper .oetl", {
        opacity: 1,
        x: `-=${0.5*SCREEN_WIDTH}`,
        ease: "power1.out",
        duration: 0.6
      }).to(playWrapper, {
        opacity: 1,
        width: '100%',
        ease: "power1.out",
        
        duration: 0.6
      }, 0).to(".player-mask", {
        backgroundPositionX: "400%",
        opacity: 1,
        duration: 0.4,
        onComplete: () => {
          _this.querySelector('.player').classList.add('center');
          innerContent.style.zIndex = '2';
        },
        onReverseComplete: () => {
          _this.querySelector('.player').classList.remove('center')
          innerContent.style.zIndex = '0';
        },
      }).to(playWrapper, {
        height: 40,
        duration: 0.2
      })
      .to(innerContent, {
        opacity: 0,
        duration: 0.2,
        onComplete: () => {
          playWrapper.style.backgroundColor = 'rgba(0,0,0,0.4)';
        },
      }, ">0.2")
      .to(playWrapper, {
        height: IS_MOBILE ? '100vh' : '100vh',
        width: '100vw',
        borderRadius: 0,
        duration: 0.45,
        ease: 'power2.out',
        backgroundColor: 'rgba(0,0,0,0)',
        onComplete: () => {
          if (this._isVideo) {
            var v = _this.querySelector('.player-wrapper video');
            if (v) v.play();
          }
        }
      })
      .fromTo(
        collapseTargets,
        {
          maxHeight: function (i, el) {
            el.style.overflow = 'hidden';
            return el.scrollHeight;
          },
          opacity: 1,
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          paddingBottom: 0
        },
        {
          maxHeight: 0,
          opacity: 0,
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          paddingBottom: 0,
          duration: 0.12,
          ease: 'power2.in',
          onComplete: function () {
            collapseTargets.forEach(function (el) {
              el.style.pointerEvents = 'none';
            });
          },
          onReverseComplete: function () {
            collapseTargets.forEach(function (el) {
              el.style.pointerEvents = '';
              el.style.overflow = '';
              gsap.set(el, {
                clearProps:
                  'maxHeight,opacity,marginTop,marginBottom,paddingTop,paddingBottom'
              });
            });
          }
        },
        '>'
      )
      .addLabel('video')
      .to(".player-mask", {
        duration: 0.4,
        opacity: 0.7,
        onComplete: () => {
          _this.querySelector('.player-mask').style.opacity = '0';
        },
        onReverseComplete: () => {
          _this.querySelector('.player-mask').style.opacity = '0';
        }
      }, 1)
      .to(".subtitle.oetl", {
        duration: 0.2,
        fontWeight: 700,
        onReverseComplete: () => {
          if(this._isVideo) {
            document.querySelector('.player-wrapper video').pause();
          }
        },
      })
      .to(bottomContent, {
        opacity: 1,
        duration: 0.2,
        translateY: -20,
      }, ">")
      .to(".player-mask", {
        duration: 0.1,
        opacity: 0,
      })

    }, 1000);

  }
  disconnectedCallback() {

  }
}
if (!window.customElements.get("scroll-trigger-open-eyes")) {
  window.customElements.define("scroll-trigger-open-eyes", ScrollTriggerOpenEyes);
}

var ScrollTriggerFullWidth = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute('sectionId');
  }
  connectedCallback() {
    setTimeout(() => {
      const SCREEN_HEIGHT = window.innerHeight;
      const SCREEN_WIDTH = window.innerWidth;
      const IS_MOBILE = SCREEN_WIDTH <= 700 ? true : false;

      // 媒体全屏动画
      const mediaFullWrapper = document.querySelector(`.media-full-wrapper-${this._id}`);
      
      const fullTl = gsap.timeline({
        scrollTrigger: {
          trigger: mediaFullWrapper,
          anticipatePin: 1,
          scrub: 1,
          start: 'top center',
          end: "top 80%",
        },
      });
      fullTl.to(mediaFullWrapper, {
        opacity: 1,
        width: '100%',
        height: '100vh',
        ease: "power1.out",
        duration: 1
      })

    }, 1000);
  }
}
if (!window.customElements.get("scroll-trigger-full-width")) {
  window.customElements.define("scroll-trigger-full-width", ScrollTriggerFullWidth);
}

var scrollTriggerHorizontal = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute('sectionId');
    this.triggers = [];
    this.currentIndex = 0; // 0 = HERO
    this.isAnimating = false;

    this.heroInner = null;
    this.heroText = null;
    this.heroTitle = null;
    this.heroImgContent = null;
    this.heroContent = null;

    this.heroScaleFrom = 1;

    this.HERO_HOLD_END = 0;
    this.LAST_HOLD = 0;

    /* ================= Hero 状态 ================= */
    this.heroState = 'expanded'; // expanded | collapsed
    this.heroTween = null;
    this.HERO_SCROLL_TRIGGER = 80;

    // ⭐ Hero 状态 class
    this.HERO_CLASS_EXPANDED = 'hero-expanded';
    this.HERO_CLASS_COLLAPSED = 'hero-collapsed';

    /* ================= Pagination ================= */
    this.paginations = [];

    /* ================= Autoplay ================= */
    this.AUTO_PLAY_DELAY = 4000;
    this.autoPlayTimer = null;
    this.lastScrollTime = Date.now();

    /* ================= Scroll 累积 ================= */
    this.scrollAccumulator = 0;
    this.SCROLL_THRESHOLD = 120;

    /* ================= 权限 ================= */
    this.isActive = false;
  }

  /* ================= 权限守卫 ================= */

  _canControl(self) {
    return (
      self &&
      self.isActive &&
      this.isActive &&
      !this.isAnimating
    );
  }

  _canAutoPlay(self) {
    return (
      self &&
      self.isActive &&
      this.isActive &&
      !this.isAnimating &&
      Date.now() - this.lastScrollTime > 1000
    );
  }

  connectedCallback() {
    setTimeout(() => this._init(), 300);
  }

  _init() {
    const section = this.querySelector(
      `#section-card-view-${this._id}`
    );
    if (!section) return;

    this.section = section;
    this.wrapper = section.querySelector('.section-wrapper');
    this.cards = gsap.utils.toArray(
      section.querySelectorAll('.section-card')
    );
    this.stickyWrapper = section.querySelector('.sticky-wrapper');

    const heroCard = this.cards[0];
    if (heroCard) {
      this.heroInner = heroCard.querySelector('.card-inner');
      this.heroText = heroCard.querySelector('.card-rich-text');
      this.heroTitle = heroCard.querySelector('.cards-title');
      this.heroContent = heroCard.querySelector('.card-content');
    }

    this.heroImgContent = document.querySelector(
      `#img-content-${this._id}`
    );

    this.GAP = 20;

    /* ================= Hero 初始态 ================= */

    if (this.heroInner) {
      const baseWidth = this.heroInner.offsetWidth || 1;
      this.heroScaleFrom = window.innerWidth / baseWidth;

      gsap.set(this.heroInner, {
        scale: this.heroScaleFrom,
        transformOrigin: 'center center',
        borderRadius: 0
      });
    }

    gsap.set([this.heroText, this.heroTitle], {
      opacity: 0,
      y: 20
    });

    if (this.heroImgContent) {
      gsap.set(this.heroImgContent, {
        opacity: 1,
        scale: 1,
        y: 0
      });
    }

    if (this.heroContent) {
      gsap.set(this.heroContent, {
        opacity: 0,
        y: 60,
        pointerEvents: 'none'
      });
    }

    this.cards.forEach(card => {
      gsap.set(card, { opacity: 1, scale: 1 });
    });

    // ⭐ 初始 Hero class
    this.section.classList.add(this.HERO_CLASS_EXPANDED);
    this.section.classList.remove(this.HERO_CLASS_COLLAPSED);

    this._initPaginations();
    this._createScrollTrigger();

    window.addEventListener('scroll', () => {
      this.lastScrollTime = Date.now();
    });

    // window.addEventListener('resize', () => {
    //   ScrollTrigger.refresh();
    // });
  }

  /* ================= Hero Tween ================= */

  _playHeroCollapse() {
    if (this.heroTween) this.heroTween.kill();

    this.isAnimating = true;
    this.heroState = 'collapsed';

    // ⭐ class
    this.section.classList.add(this.HERO_CLASS_COLLAPSED);
    this.section.classList.remove(this.HERO_CLASS_EXPANDED);

    this.heroTween = gsap.timeline({
      defaults: { duration: 0.8, ease: 'power3.out' },
      onComplete: () => {
        this.isAnimating = false;
        this._syncPagination(0, 1);
      }
    });

    this.heroTween
      .to(this.heroInner, {
        scale: 1,
        borderRadius: 12
      }, 0)
      .to(this.heroImgContent, {
        opacity: 0,
        scale: 0.85,
        y: -40
      }, 0)
      .to([this.heroTitle, this.heroText], {
        opacity: 1,
        y: 0
      }, 0)
      .to(this.heroContent, {
        opacity: 1,
        y: 0,
        pointerEvents: 'auto'
      }, 0.15);
  }

  _playHeroExpand() {
    if (this.heroTween) this.heroTween.kill();

    this.isAnimating = true;
    this.heroState = 'expanded';

    // ⭐ class
    this.section.classList.add(this.HERO_CLASS_EXPANDED);
    this.section.classList.remove(this.HERO_CLASS_COLLAPSED);

    this.heroTween = gsap.timeline({
      defaults: { duration: 0.8, ease: 'power3.out' },
      onComplete: () => {
        this.isAnimating = false;
      }
    });

    this.heroTween
      .to(this.heroInner, {
        scale: this.heroScaleFrom,
        borderRadius: 0
      }, 0)
      .to(this.heroImgContent, {
        opacity: 1,
        scale: 1,
        y: 0
      }, 0)
      .to([this.heroTitle, this.heroText], {
        opacity: 0,
        y: 20
      }, 0)
      .to(this.heroContent, {
        opacity: 0,
        y: 60,
        pointerEvents: 'none'
      }, 0);
  }

  /* ================= Pagination ================= */

  _initPaginations() {
    const paginations = this.section.querySelectorAll(
      '.card-swiper-pagination'
    );

    this.paginations = [];

    paginations.forEach(pagination => {
      pagination.innerHTML = '';
      const bullets = [];

      for (let i = 0; i < this.cards.length; i++) {
        const bullet = document.createElement('div');
        bullet.className = 'swiper-pagination-bullet';

        const progress = document.createElement('span');
        progress.className = 'bullet-progress';

        bullet.appendChild(progress);
        pagination.appendChild(bullet);
        bullets.push({ bullet, progress });
      }

      this.paginations.push(bullets);
    });

    this._syncPagination(0, 0);
  }

  _syncPagination(index, progress = 0) {
    this.paginations.forEach(bullets => {
      bullets.forEach((item, i) => {
        item.bullet.classList.toggle(
          'swiper-pagination-bullet-active',
          i === index
        );
        item.progress.style.width =
          i === index ? `${progress * 100}%` : '0%';
      });
    });
  }

  /* ================= ScrollTrigger ================= */

  _getStep() {
    return this.cards.length
      ? this.cards[0].offsetWidth + this.GAP
      : 0;
  }

  _snapToIndex(index, self) {
    if (!this._canControl(self)) return;

    this.isAnimating = true;
    const step = this._getStep();

    gsap.to(this.wrapper, {
      x: -index * step,
      duration: 0.8,
      ease: 'power3.out',
      onComplete: () => {
        this.isAnimating = false;
        this.scrollAccumulator = 0;
        this._syncPagination(index, 1);
      }
    });

    self.scroll(
      self.start + this.HERO_HOLD_END + index * step
    );
  }

  _createScrollTrigger() {
    this.triggers.forEach(t => t.kill());
    this.triggers.length = 0;

    const step = this._getStep();
    const cardCount = this.cards.length - 1;

    this.HERO_HOLD_END = step * 0.8;
    this.LAST_HOLD = step * 0.6;

    const totalDistance =
      this.HERO_HOLD_END +
      step * cardCount +
      this.LAST_HOLD;

    const trigger = ScrollTrigger.create({
      trigger: this.stickyWrapper,
      start: 'top top',
      end: `+=${totalDistance}`,
      pin: true,
      scrub: false,

      onEnter: () => (this.isActive = true),
      onEnterBack: () => (this.isActive = true),

      onLeave: () => {
        this.isActive = false;
        this.isAnimating = false;
        this.scrollAccumulator = 0;
      },

      onLeaveBack: () => {
        this.isActive = false;
        this.isAnimating = false;
        this.scrollAccumulator = 0;
      },

      onUpdate: self => {
        if (!this._canControl(self)) return;

        const scrollY = self.scroll() - self.start;

        /* ============ HERO SNAP ============ */
        if (scrollY <= this.HERO_HOLD_END) {
          const velocity = self.getVelocity();

          if (
            velocity > this.HERO_SCROLL_TRIGGER &&
            this.heroState === 'expanded'
          ) {
            this._playHeroCollapse();
          }

          if (
            velocity < -this.HERO_SCROLL_TRIGGER &&
            this.heroState === 'collapsed'
          ) {
            this._playHeroExpand();
          }

          this.currentIndex = 0;
          gsap.set(this.wrapper, { x: 0 });
          this.scrollAccumulator = 0;
          return;
        }

        /* ============ SLIDE 累积滚动 ============ */
        const base =
          this.HERO_HOLD_END +
          this.currentIndex * step;

        const delta = scrollY - base;

        const isLast = this.currentIndex === cardCount;
        const isScrollingUp = delta < 0;

        const threshold = isLast && isScrollingUp
          ? this.SCROLL_THRESHOLD * 0.4
          : this.SCROLL_THRESHOLD;

        this.scrollAccumulator += isLast && isScrollingUp
          ? delta * 1.5
          : delta;

        if (Math.abs(this.scrollAccumulator) < threshold) return;

        const dir = this.scrollAccumulator > 0 ? 1 : -1;
        const next = gsap.utils.clamp(
          1,
          cardCount,
          this.currentIndex + dir
        );

        if (next !== this.currentIndex) {
          this.currentIndex = next;
          this._snapToIndex(next, self);
        }
      }
    });

    this.triggers.push(trigger);
  }
};

if (!window.customElements.get('scroll-trigger-horizontal-width')) {
  window.customElements.define(
    'scroll-trigger-horizontal-width',
    scrollTriggerHorizontal
  );
}

var ScrollTriggerAccordionTabs = class extends HTMLElement {
    constructor() {
        super();
        this._id = this.getAttribute('sectionId');
        this._layoutHost = null;
        this._accordionTab = null;
        this._addToCartBar = null;
        this._atcObserver = null;
        this._headerObserver = null;
        this._sectionHeader = null;
        this._headerInView = false;
        this._headerHiddenByProgress = false;
        this._headerScrollRaf = null;
        this._dynamicStickyHeaderTop = false;
        this._onHeaderProgressScroll = this._onHeaderProgressScroll.bind(this);
        this._updateViewportVars = this._updateViewportVars.bind(this);
        this._updateDynamicStickyHeaderTop = this._updateDynamicStickyHeaderTop.bind(this);
        this._updateBottomOffset = this._updateBottomOffset.bind(this);
        this._updateCardHeight = this._updateCardHeight.bind(this);
        this._desktopHeaderMedia = null;
        this._onHeaderDesktopChange = this._onHeaderDesktopChange.bind(this);
    }
    connectedCallback() {
        const titleColor = this.getAttribute('title-color');
        const titleActiveColor = this.getAttribute('title-active-color');
        const enableScrollContentSwitch = this.hasAttribute('enable-scroll-content-switch');
        const enableStickyHeaderDesktop = this.hasAttribute('sticky-header-desktop');
        this._dynamicStickyHeaderTop = this.hasAttribute('dynamic-sticky-header-top');

        const images = this.querySelectorAll('.accodion-card-box-picture');
        const accordionBox = document.querySelector(`#accordion-tabs-wrap-wrap-${this._id}`);
        const accordionTab = document.querySelector(`#accordion-tabs-contain-${this._id}`);
        const accordionCard = document.querySelector(`#accordion-card-${this._id}`);

        const titles = this.querySelectorAll('.accordion-tab-title');
        const inlineContents = this.querySelectorAll('.accordion-tab-box > .accordion-tab-content');
        const switchContents = this.querySelectorAll('.accordion-tab-content-panel');
        const contents = enableScrollContentSwitch ? switchContents : inlineContents;
        const constentImages = this.querySelectorAll('.accordion-tab-content-image');
        const dots = this.querySelectorAll('.accordion-tab-dot');
        this._layoutHost = this.closest('.shopify-section') || this;
        this._accordionTab = accordionTab;
        this._sectionHeader = (this._layoutHost && this._layoutHost.querySelector('section-header.section-header'))
            || (this.previousElementSibling?.classList.contains('section-header')
                ? this.previousElementSibling
                : null);
        this._addToCartBar = document.querySelector('.add-to-cart-bar-wrapper');
        this._dynamicStickyHeaderTop =
            this._dynamicStickyHeaderTop &&
            this._hasSectionHeaderTitle();
        this._updateBottomOffset();
        this._updateViewportVars();
        this._updateDynamicStickyHeaderTop();
        window.addEventListener('resize', this._updateViewportVars, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this._updateViewportVars, { passive: true });
            window.visualViewport.addEventListener('scroll', this._updateViewportVars, { passive: true });
        }

        if (this._addToCartBar) {
            this._atcObserver = new MutationObserver(() => {
                this._updateBottomOffset();
                this._updateCardHeight();
                this._updateViewportVars();
            });

            this._atcObserver.observe(this._addToCartBar, {
                attributes: true,
                attributeFilter: ['class', 'style'],
            });
        }

        if (enableScrollContentSwitch) {
            if (this._sectionHeader) {
                if (!('IntersectionObserver' in window)) {
                    this._headerInView = true;
                    this._syncHeaderVisibility();
                } else {
                    this._headerObserver = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            this._headerInView = entry.isIntersecting;
                            this._syncHeaderVisibility();
                        });
                    }, {
                        rootMargin: '0px 0px -15% 0px',
                        threshold: 0.15
                    });

                    this._headerObserver.observe(this._sectionHeader);
                }

                if (enableStickyHeaderDesktop) {
                    this._desktopHeaderMedia = window.matchMedia('(min-width: 768px)');
                    this._onHeaderDesktopChange();
                    if (this._desktopHeaderMedia.addEventListener) {
                        this._desktopHeaderMedia.addEventListener('change', this._onHeaderDesktopChange);
                    } else if (this._desktopHeaderMedia.addListener) {
                        this._desktopHeaderMedia.addListener(this._onHeaderDesktopChange);
                    }
                }
            }
        }

        setTimeout(() => {
            // 固定滚动容器的处理
        function setupAccordionWrap(scrollTriggerConfig) {
            gsap.timeline({
                scrollTrigger: {
                    ...scrollTriggerConfig
                }
            });
        }

        // 更新标题、内容和图片的状态
        function updateAccordionContent(index) {
            titles.forEach((title, i) => {
                title.style.color = i === index ? titleActiveColor : titleColor;
                title.classList.toggle('is-active', i === index);
            });
            
            if(contents && contents.length > 0) {
                contents.forEach((content, i) => {
                    // content.style.display = i === index ? "block" : "none";
                    if (i === index || (!enableScrollContentSwitch && i === 0)) {
                        content.style.display = "block"; 
                        setTimeout(() => content.classList.add('expand'), 100); 
                    } else {
                        content.classList.remove('expand'); 
                        setTimeout(() => content.style.display = "none", 30); 
                    }
                });
            }
            
            constentImages.forEach((contentImage, i) => {
                // contentImage.style.display = i === index ? "block" : "none";
                if (i === index) {
                    contentImage.style.display = "block"; 
                    setTimeout(() => contentImage.classList.add('expand'), 100); 
                } else {
                    contentImage.classList.remove('expand'); 
                    setTimeout(() => contentImage.style.display = "none", 30); 
                }
            })

            // dots.forEach((dot, i) => {
            //     dot.style.backgroundColor = i === index ? '#000' : '#D9D9D9';
            // });

            dots.forEach((dot, i) => {
                if (i === index) {
                    dot.classList.add('dot-active');
                } else {
                    dot.classList.remove('dot-active');
                }
            });

            images.forEach((image, i) => {
                image.style.opacity = i === index ? "1" : "0";
                image.style.zIndex = i === index ? "2" : "1";
            });
        }

        // 设置图片的滚动动画
        function setupImageScrollAnimation(scrollTriggerBaseConfig) {
            // 添加标题点击事件
            titles.forEach((title, index) => {
                title.setAttribute('data-index', index);
                title.addEventListener('click', () => {
                    updateAccordionContent(index);

                    // 使用 scrollIntoView 实现平滑滚动
                    images[index].scrollIntoView({
                        behavior: 'smooth', // 平滑滚动
                        block: 'center', // 滚动后目标元素在视口中居中
                    });
                });
            });

            // 圆点点击事件
            dots.forEach((dot, index) => {
                // dot.setAttribute('data-index', index);
                dot.addEventListener('click', () => {
                    updateAccordionContent(index);

                    // 使用 scrollIntoView 实现平滑滚动
                    images[index].scrollIntoView({
                        behavior: 'smooth', // 平滑滚动
                        block: 'center', // 滚动后目标元素在视口中居中
                    });
                });
            });

            images.forEach((image, index) => {
                gsap.to(image, {
                    scrollTrigger: {
                        ...scrollTriggerBaseConfig,
                        start: `${index * 300}px top`,
                        end: `${(index + 1) * 300}px top`,
                        onEnter: () => {
                            updateAccordionContent(index);
                        },
                        onEnterBack: () => {
                            updateAccordionContent(index);
                        }
                    },
                    opacity: 1,
                    zIndex: 2
                });
            });
        }

        function initAccordionWrap() {
            // 主逻辑
            setupAccordionWrap(
                {
                    trigger: accordionBox,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true
                },
                accordionTab
            );
        
            setupImageScrollAnimation({
                trigger: accordionCard,
                scrub: false
            });

            updateAccordionContent(0);
        }

        initAccordionWrap();

        window.addEventListener('resize', () => {
            initAccordionWrap();
        });
        }, 1000);
    }

    _syncHeaderVisibility() {
        if (!this._sectionHeader) return;

        this._sectionHeader.classList.toggle(
            'is-visible',
            this._headerInView && !this._headerHiddenByProgress
        );

        this._updateBottomOffset();
        this._updateViewportVars();
    }

    _onHeaderProgressScroll() {
        if (this._desktopHeaderMedia && !this._desktopHeaderMedia.matches) {
            this._headerHiddenByProgress = false;
            this._syncHeaderVisibility();
            return;
        }

        if (this._headerScrollRaf) return;

        this._headerScrollRaf = window.requestAnimationFrame(() => {
            this._headerScrollRaf = null;
            this._updateDynamicStickyHeaderTop();

            const rect = this.getBoundingClientRect();
            const scrollableDistance = Math.max(rect.height - this._getViewportHeight(), 1);
            const progress = Math.min(Math.max(-rect.top / scrollableDistance, 0), 1);

            if (progress >= 0.7) {
                this._headerHiddenByProgress = true;
            } else if (progress <= 0.4) {
                this._headerHiddenByProgress = false;
            }

            this._syncHeaderVisibility();
        });
    }

    _onHeaderDesktopChange() {
        if (this._desktopHeaderMedia && this._desktopHeaderMedia.matches) {
            this._updateBottomOffset();
            this._onHeaderProgressScroll();
            window.addEventListener('scroll', this._onHeaderProgressScroll, { passive: true });
            window.addEventListener('resize', this._onHeaderProgressScroll, { passive: true });
            return;
        }

        this._headerHiddenByProgress = false;
        if (this._headerScrollRaf) {
            window.cancelAnimationFrame(this._headerScrollRaf);
            this._headerScrollRaf = null;
        }
        window.removeEventListener('scroll', this._onHeaderProgressScroll);
        window.removeEventListener('resize', this._onHeaderProgressScroll);
        this._updateBottomOffset();
        this._syncHeaderVisibility();
    }

    disconnectedCallback() {
        if (this._headerObserver) {
            this._headerObserver.disconnect();
            this._headerObserver = null;
        }

        if (this._headerScrollRaf) {
            window.cancelAnimationFrame(this._headerScrollRaf);
            this._headerScrollRaf = null;
        }

        window.removeEventListener('scroll', this._onHeaderProgressScroll);
        window.removeEventListener('resize', this._onHeaderProgressScroll);

        if (this._desktopHeaderMedia) {
            if (this._desktopHeaderMedia.removeEventListener) {
                this._desktopHeaderMedia.removeEventListener('change', this._onHeaderDesktopChange);
            } else if (this._desktopHeaderMedia.removeListener) {
                this._desktopHeaderMedia.removeListener(this._onHeaderDesktopChange);
            }
            this._desktopHeaderMedia = null;
        }

        if (this._atcObserver) {
            this._atcObserver.disconnect();
            this._atcObserver = null;
        }

        window.removeEventListener('resize', this._updateViewportVars);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this._updateViewportVars);
            window.visualViewport.removeEventListener('scroll', this._updateViewportVars);
        }
    }

    _getViewportHeight() {
        if (window.visualViewport?.height) return window.visualViewport.height;
        return window.innerHeight || document.documentElement.clientHeight || 0;
    }

    _updateViewportVars() {
        if (!this._layoutHost) return;

        const viewportHeight = this._getViewportHeight();
        const styles = window.getComputedStyle(this._layoutHost);
        const fixedTopOffset = Number.parseFloat(styles.getPropertyValue('--accordion-fixed-top-offset')) || 64;
        const bottomOffset = Number.parseFloat(styles.getPropertyValue('--accordion-bottom-offset')) || 0;
        const visibleHeight = Math.max(0, viewportHeight - fixedTopOffset - bottomOffset);

        this._layoutHost.style.setProperty('--accordion-viewport-height', `${viewportHeight}px`);
        this._layoutHost.style.setProperty('--accordion-visible-height', `${visibleHeight}px`);
        this._updateDynamicStickyHeaderTop();
        this._updateCardHeight();
    }

    _updateBottomOffset() {
        if (!this._layoutHost) return;

        const screenWidth = window.screen?.width || window.innerWidth || document.documentElement.clientWidth || 0;
        const hasVisibleAddToCartBar =
            this._addToCartBar &&
            !this._addToCartBar.classList.contains('hidden') &&
            (() => {
                const addToCartStyles = window.getComputedStyle(this._addToCartBar);
                return addToCartStyles.display !== 'none' && addToCartStyles.visibility !== 'hidden';
            })();

        const bottomOffset = hasVisibleAddToCartBar
            ? (screenWidth > 1920 ? 30 : screenWidth === 1920 ? 50 : 80)
            : 0;
        const containTopAdjust = hasVisibleAddToCartBar ? 50 : 0;

        this._layoutHost.style.setProperty('--accordion-bottom-offset', `${bottomOffset}px`);
        this._layoutHost.style.setProperty('--accordion-contain-top-adjust', `${containTopAdjust}px`);
        this._updateCardHeight();
    }

    _getAccordionCardHeight() {
        const baseHeight = Number.parseFloat(this.getAttribute('card-height'));
        if (!Number.isFinite(baseHeight) || baseHeight <= 0) return null;

        const compact = window.matchMedia('(max-width: 1519px)').matches;
        return compact ? Math.round(baseHeight * 0.84) : baseHeight;
    }

    _updateCardHeight() {
        const card = document.querySelector(`#accordion-card-${this._id}`);
        const tabs = this.querySelector('.accordion-tabs');
        const scaledHeight = this._getAccordionCardHeight();
        if (!scaledHeight || !card || !tabs || !this._layoutHost) return;

        const hasAddToCartBar = Boolean(document.querySelector('.add-to-cart-bar-wrapper'));
        const minHeight = hasAddToCartBar ? scaledHeight : Math.round(scaledHeight * 1.1);

        this._layoutHost.style.setProperty('--accordion-card-min-height', `${minHeight}px`);
        card.style.removeProperty('height');
        tabs.style.removeProperty('height');
    }

    _hasSectionHeaderTitle() {
        if (!this._sectionHeader) return false;

        const titleElement = this._sectionHeader.querySelector('.prose > .h2, .prose > h2');
        return Boolean(titleElement?.textContent?.trim());
    }

    _updateDynamicStickyHeaderTop() {
        if (!this._dynamicStickyHeaderTop || !this._sectionHeader || !this._accordionTab) return;
        if (this._desktopHeaderMedia && !this._desktopHeaderMedia.matches) return;

        const accordionTop = this._accordionTab.getBoundingClientRect().top;
        const headerHeight = this._sectionHeader.getBoundingClientRect().height;
        const styles = window.getComputedStyle(this._layoutHost);
        const containTopAdjust = Number.parseFloat(styles.getPropertyValue('--accordion-contain-top-adjust')) || 0;
        const computedTop = accordionTop - headerHeight - 58 + containTopAdjust - 10;

        this._sectionHeader.style.setProperty('--accordion-dynamic-section-header-top', `${computedTop}px`);
    }
}
if (!window.customElements.get("scroll-trigger-accordion-tabs")) {
  window.customElements.define("scroll-trigger-accordion-tabs", ScrollTriggerAccordionTabs);
}


  var ScrollScaleText = class extends HTMLElement {
    constructor() {
      super();
      this._id = this.getAttribute('sectionId');
    }
    connectedCallback() { 
        const container = document.querySelector(`#image-container-wrap-${this._id}`);
        let lastScrollY = window.scrollY;

        const section = this.closest(".shopify-section");
        const nextSection = section.nextElementSibling;
    
        const resetAnimation = () => {
            container.classList.remove('scroll-scale-text');
            // Trigger reflow to restart the animation
            void container.offsetWidth;
            container.classList.add('scroll-scale-text');
    
    
            setTimeout(() => {
                nextSection.scrollIntoView({
                    behavior: 'smooth', // 平滑滚动
                    block: 'start', // 滚动到目标元素顶部
                });
            }, 1000)
        };
    
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const currentScrollY = window.scrollY;
    
                if (entry.isIntersecting && currentScrollY > lastScrollY) {
                    // Trigger animation only when scrolling down
                    resetAnimation();
                }
    
                // Update the last scroll position
                lastScrollY = currentScrollY;
            });
        }, { threshold: 0.5 });
    
        observer.observe(container);
    } 

}

if (!window.customElements.get("scroll-scale-text")) {
    window.customElements.define("scroll-scale-text", ScrollScaleText);
  }

  var ScrollFadeOutText = class extends HTMLElement {
    constructor() {
      super();
      this._id = this.getAttribute('sectionId');
    }
    connectedCallback() { 
        setTimeout(() => {
        const fadeText = this.querySelector("#fadeText");
        const image = this.querySelector(".hidden-image");
        const lines = this.querySelectorAll(".line");
        
        // 初始化 GSAP 时间线
        const SFtimeline = gsap.timeline({
          scrollTrigger: {
            trigger: fadeText, // 滚动触发目标为文字区域
            start: "top center", // 滚动开始位置
            end: "bottom+=600 center", // 滚动结束位置
            scrub: 1 // 与滚动关联
          },
        });
        
        // 将文字分解为单个字符并保留空格
        lines.forEach((line) => {
          const textArray = line.textContent.split("");
          line.innerHTML = textArray
            .map((char) => {
              if (char === " ") {
                return `<span class="space">&nbsp;</span>`;
              }
              return `<span>${char}</span>`;
            })
            .join("");
        });
        
        // 添加文字动画到时间线
        lines.forEach((line, lineIndex) => {
          const chars = line.querySelectorAll("span");
          let staggerDelay = 0.2 * (lineIndex + 1);  // 默认的 stagger 延迟

          // 为第一行增加更长的延迟
          if (lineIndex === 0) {
            staggerDelay = 2;  // 增加第一行的延迟
          }
          SFtimeline.to(
            chars,
            {
              color: "rgba(255, 255, 255, 1)", // 从透明变为白色
              stagger: staggerDelay // 每行增加动画延迟
            },
            "+=0" // 确保文字动画是连续的
          );
        });
        
        // 添加图片动画到时间线
        SFtimeline.to(
          image,
          {
            scale: 2, // 图片从缩小状态恢复到正常大小
            opacity: 1, // 渐变显示
          },
          "+=0.2" // 在文字动画完成后延迟0.2秒执行图片动画
        );
        }, 1000)
       
    }

}

if (!window.customElements.get("scroll-fade-out-text")) {
    window.customElements.define("scroll-fade-out-text", ScrollFadeOutText);
  }

  var ScrollUpText = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute('sectionId');
  }
  connectedCallback() { 
    const swiperContainer = this.querySelector('.fade-up-wrap');

    const swiperPaginationWrap = this.querySelectorAll(`.fade-up-data`);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { 
            swiperPaginationWrap.forEach((e, index) => {
              e.classList.add("fade-up-animation");
              e.style.animationDelay = `${index * 0.3}s`; // 每个元素依次延迟
            });
            console.log('进入可视区')
          } else {
            // swiperPaginationWrap.style.display = 'none';
            swiperPaginationWrap.forEach(e => {
              e.classList.remove("fade-up-animation");
            });
            console.log('离开可视区')
          }
        });
      },
      { threshold: 0.1 } // 当 50% 可见时触发
    );
    
    observer.observe(swiperContainer);
  }

}

if (!window.customElements.get("scroll-up-text")) {
  window.customElements.define("scroll-up-text", ScrollUpText);
}
var ImageSlideRevealText = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute("sectionId");
    this.offset_height_pc = parseFloat(this.getAttribute("offset-height-pc")) || 0; // 获取图片偏移高度
    this.offset_height_mo = parseFloat(this.getAttribute("offset-height-mo")) || 0; // 获取图片偏移高度
  }

connectedCallback() {
    this._initializeText();
    setTimeout(() => {
        this._setupInitialImageState();
        this._createScrollTrigger();
        window.addEventListener("resize", this._onResize.bind(this)); // Add resize event listener
    }, 1000);
}

_onResize() {
    // Recalculate character offsets and reset image state on resize
    this._charOffsets = null; // Clear cached offsets
    this._setupInitialImageState(); // Reset image state
    // ScrollTrigger.refresh(); // Refresh ScrollTrigger to recalculate positions
}

_initializeText() {
    const fadeText = this.querySelector("#fadeText");
    const line = this.querySelector(".line");

    // 拆分文字为单个字符的 span 元素
    const textArray = line.textContent.split("");
    line.innerHTML = textArray
        .map((char) =>
            char === " "
                ? `<span class="space">&nbsp;</span>`
                : `<span>${char}</span>`
        )
        .join("");

    this._allChars = fadeText.querySelectorAll("span:not(.space)");
}

_setupInitialImageState() {
    const imageContainer = this.querySelector(".image-container");
    const image = this.querySelector("img");

    // 设置初始状态：图片在父容器左侧外
    gsap.set(imageContainer, { x: "-100%", opacity: 0 });
    gsap.set(image, { scale: 1 });
}

_createScrollTrigger() {
    const fadeText = this.querySelector("#fadeText");
    const imageContainer = this.querySelector(".image-container");
    const parentElement = this;

    ScrollTrigger.create({
        trigger: fadeText,
        start: "top center",
        end: "bottom+=2000 center",
        scrub: 2,
        onUpdate: (self) => {
            this._handleScrollUpdate(self, fadeText, imageContainer, parentElement);
        },
    });
}

_handleScrollUpdate(self, fadeText, imageContainer, parentElement) {
    const progress = self.progress;

    // 缓存字符位置（相对 fadeText）
    if (!this._charOffsets) {
        this._charOffsets = Array.from(this._allChars).map((char) => {
            const rect = char.getBoundingClientRect();
            const parentRect = fadeText.getBoundingClientRect();
            return rect.left - parentRect.left;
        });
    }

    const revealProgress = Math.min(progress / 0.3, 1); // 前 30% 逐渐 reveal 文字
    const revealChars = Math.floor(this._allChars.length * revealProgress);

    // 控制文字变白
    this._allChars.forEach((char, index) => {
        if (index < revealChars) {
            char.style.color = "rgb(0, 0, 0, 1)";
        } else {
            char.style.color = "rgba(255,255,255,0)";
        }
    });

    // 获取变白文字末尾的 X 坐标
    let lastCharX = 0;
    if (revealChars > 0) {
        const lastChar = this._allChars[revealChars - 1];
        const rect = lastChar.getBoundingClientRect();
        const parentRect = fadeText.getBoundingClientRect();
        lastCharX = rect.left - parentRect.left + rect.width;
    }

    const containerWidth = parentElement.offsetWidth;
    const imageWidth = imageContainer.offsetWidth;

    // 控制图片滑动
    let finalX = -imageWidth; // 初始位置在父元素盒子外的最左侧
    if (lastCharX == 0) {
        finalX = revealChars * imageWidth; // 还未到达最后一个变白字符
    } else if (lastCharX >= fadeText.offsetWidth * 0.95) {
        const smoothTransition = gsap.utils.interpolate(
            (containerWidth - fadeText.offsetWidth) / 2 + lastCharX,
            revealChars * imageWidth
        );
        finalX = smoothTransition(progress); // 平滑过渡
        if (
            finalX < containerWidth &&
            lastCharX >= fadeText.offsetWidth * 0.95
        ) {
            const transitionProgress = (progress - 0.9) / 0.1; // Adjust transition range (e.g., last 20% of progress)
            finalX = gsap.utils.interpolate(
                finalX,
                containerWidth
            )(Math.min(Math.max(transitionProgress, 0), 1)); // Clamp between 0 and 1 for smooth transition
        } else if (finalX >= containerWidth) {
            finalX = containerWidth; // Ensure it doesn't overshoot
        }
    } else {
        finalX = (containerWidth - fadeText.offsetWidth) / 2 + lastCharX;
    }

    const currentChar = this._allChars[revealChars - 1] || this._allChars[0];
    const finalY_pc = currentChar.offsetTop - window.innerHeight / 2 + (imageContainer.offsetHeight / 2) - (currentChar.offsetHeight /2) + this.offset_height_pc;
    const finalY_mo = currentChar.offsetTop - window.innerHeight / 2 + (imageContainer.offsetHeight / 2) - (currentChar.offsetHeight / 2) + this.offset_height_mo;

    const finalY = window.innerWidth > 700 ? finalY_pc : finalY_mo; // 图片偏移高度

    // 更新图片滑动位置和透明度
    if (revealChars >= this._allChars.length) {
        gsap.to(imageContainer, {
            opacity: 0,
            duration: 0.1,
        });
    } else {
        gsap.set(imageContainer, {
            x: finalX,
            y: finalY,
            opacity: progress > 0.01 ? 1 : 0, 
        });
    }
}
}

// 自定义元素定义
if (!window.customElements.get("image-slide-reveal-text")) {
  window.customElements.define("image-slide-reveal-text", ImageSlideRevealText);
}

// dropdown 
var CustomDropdown = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .dropdown {
          position: relative;
          display: inline-block;
          width: 100%;
          cursor: pointer;
        }

      </style>
      <div class="dropdown">
        <slot name="selected"></slot>
        <slot name="menu"></slot>
      </div>
    `;

    this.selectedItemElement = null;
    this.dropdownMenu = null;

    this.shadowRoot.addEventListener("slotchange", () => {
      this.setupDropdown();
    });

    // 监听全局点击事件，关闭下拉菜单
    document.addEventListener("click", this.closeDropdown.bind(this));
  }

  closeDropdown(event) {
    if (!this.contains(event.target)) {
      this.dropdownMenu.classList.remove("show");
    }
  }

  setupDropdown() {
    this.selectedItemElement = this.querySelector('[slot="selected"]');
    this.dropdownMenu = this.querySelector('[slot="menu"]');

    if (!this.selectedItemElement || !this.dropdownMenu) {
      console.warn("缺少 slot='selected' 或 slot='menu' 元素");
      return;
    }

    const dropdown = this.shadowRoot.querySelector(".dropdown");

    // 先移除旧的事件监听，防止重复绑定
    this.selectedItemElement.removeEventListener(
      "click",
      this.toggleDropdown
    );

    // 绑定点击事件
    this.toggleDropdown = (event) => {
      event.stopPropagation();
      this.dropdownMenu.classList.toggle("show");
      this.selectedItemElement.classList.toggle("show");
    };

    this.selectedItemElement.addEventListener(
      "click",
      this.toggleDropdown
    );

    this.dropdownMenu
      .querySelectorAll(".custom-drop-item")
      .forEach((item) => {
        item.addEventListener("click", (event) => this.selectItem(event));
        
    });

     // 设置默认选中项
      if (this.hasAttribute('auto-select')) {
        const items = this.dropdownMenu.querySelectorAll(".custom-drop-item");

        if (items.length > 0) {
          const firstItem = items[0];
          firstItem.classList.add("active");
          this.selectedItemElement.textContent = firstItem.textContent; 
        // 如果有 auto-select 属性，自动选择第一个项，并触发事件
          const index = firstItem.getAttribute("data-index");
          const block_index = firstItem.getAttribute("block-index");
          const value = firstItem.textContent;
          this.dispatchEvent(
            new CustomEvent("itemSelected", {
              detail: { index, value, block_index }
            })
          );
        }
    }
  }

  selectItem(event) {
    event.stopPropagation();
    const index = event.target.getAttribute("data-index");
    const block_index = event.target.getAttribute("block-index");
    const value = event.target.textContent;
    this.selectedItemElement.textContent = value;
    this.dropdownMenu.classList.remove("show");

      // 清除所有 active 类
    this.dropdownMenu
    .querySelectorAll(".custom-drop-item.active")
    .forEach((item) => item.classList.remove("active"));
    // 设置当前为 active
    event.target.classList.add("active");

    // 触发自定义事件
    this.dispatchEvent(
      new CustomEvent("itemSelected", {
        detail: { index, value, block_index }
      })
    );
  }
};

if (!window.customElements.get("custom-dropdown")) {
  window.customElements.define("custom-dropdown", CustomDropdown);
}

var CountdownTimer = class extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.startTime = new Date(this.getAttribute('start-time'));
    this.endTime = new Date(this.getAttribute('end-time'));
    this.hideAfterEnd = this.getAttribute('hide-after-end') === 'true';
    this.endText = this.getAttribute('end-text') || 'Countdown Ended';
    this.timezoneOffset = parseFloat(this.getAttribute('timezone-offset')) || 0;
    this.padDigits = this.getAttribute('pad-digits') === 'true';

    this.daysElement = this.querySelector('#countdown-days');
    this.hoursElement = this.querySelector('#countdown-hours');
    this.minutesElement = this.querySelector('#countdown-minutes');
    this.secondsElement = this.querySelector('#countdown-seconds');
    // Most markups put `.countdown-wrap` on this element itself, so fall back to it.
    this.container = this.querySelector('.countdown-wrap') ?? this;
    // Optional `hide-target` selector: when the countdown ends with hide-after-end, hide that
    // ancestor (e.g. the whole promo card) instead of only the timer.
    const hideTarget = this.getAttribute('hide-target');
    this.hideElement = (hideTarget && this.closest(hideTarget)) || this;

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  updateCountdown() {
    const now = new Date();
    const nowInTargetTZ = new Date(now.getTime() + this.timezoneOffset * 60 * 60 * 1000);

    if (nowInTargetTZ < this.startTime) {
      this.style.display = 'none';
      return;
    } else {
      this.style.display = 'flex';
    }

    let timeLeft = this.endTime - nowInTargetTZ;

    if (timeLeft <= 0) {
      // In the theme editor an ended countdown shows its end text instead of hiding, so the block stays selectable.
      if (this.hideAfterEnd && !window.Shopify?.designMode) {
        this.style.display = 'none';
        this.hideElement.hidden = true;
      } else {
        this.container.innerHTML = this.endText;
      }
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    const formatValue = (value) => this.padDigits ? String(value).padStart(2, '0') : String(value);

    if (this.daysElement) this.daysElement.textContent = formatValue(days);
    if (this.hoursElement) this.hoursElement.textContent = formatValue(hours);
    if (this.minutesElement) this.minutesElement.textContent = formatValue(minutes);
    if (this.secondsElement) this.secondsElement.textContent = formatValue(seconds);
  }
}

if (!window.customElements.get("countdown-timer")) {
    window.customElements.define("countdown-timer", CountdownTimer);
  }

    // js/common/overlay/dialog-modal.js
var ModalDialog = class extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

       // **Dynamic style creation, adapt to any location**
        const style = document.createElement('style');
        style.textContent = `
            :host {
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: none;
                align-items: center;
                justify-content: center;
                background: rgba(0, 0, 0, 0.5);
            }
            :host([open]) {
                display: flex;
            }
            .modal {
                position: relative;
                background: var(--modal-background, #fff);
                border-radius: var(--modal-border-radius, 8px);
            }
        `;

        this.shadowRoot.appendChild(style);

     // **Create pop-up content**
        const modalWrapper = document.createElement('div');
        modalWrapper.classList.add('modal');
        modalWrapper.innerHTML = `<slot></slot>`;

        this.shadowRoot.appendChild(modalWrapper);
    }

    static get observedAttributes() {
        return ['open'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'open') {
            this._toggleEscapeKey(newValue !== null);
        }
    }

    connectedCallback() {
        // **Click on the mask layer to close**
        this.addEventListener('click', (e) => {
            if (e.target === this) this.close();
        });

        // **Click the Close button to close**
      this.shadowRoot.addEventListener('click', (e) => {
        if (e.target.closest('.close')) {
          this.close();
        }
      });

        // **Automatically find and bind buttons with `data-key`**
        // Note: Must be initialized at the beginning; otherwise, the event may not bind properly.
        // Global event delegation is not used to avoid event bubbling.
        document.querySelectorAll(`[data-modal="openModal"][data-key="${this.dataset.key}"]`)
            .forEach(button => button.addEventListener('click', () => this.open()));
    }

    open() {
        this.setAttribute('open', '');
    }

    close() {
        this.removeAttribute('open');
    }

    _toggleEscapeKey(enable) {
        if (enable) {
            this._handleEscape = (e) => {
                if (e.key === 'Escape') this.close();
            };
            document.addEventListener('keydown', this._handleEscape);
        } else {
            document.removeEventListener('keydown', this._handleEscape);
        }
    }
}

if (!window.customElements.get('modal-dialog')) {
  window.customElements.define('modal-dialog', ModalDialog);
}

var HoverPopup = class extends HTMLElement {
  constructor() {
    super();
    this._hideTimer = null;
    this._isInitialized = false;
    this._header = document.querySelector(".shopify-section--header");

    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: relative;
          display: inline-block;
        }
        .popup {
          position: absolute;
          top: calc(100% + 20px);
          right: 0;
          background: #fff;
          color: #000;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          padding: 20px 24px;
          width: 293px;
          opacity: 0;
          transform: translateY(10px);
          pointer-events: none;
          transition: opacity 0.3s ease, transform 0.3s ease;
          z-index: 10;
        }
        .popup::before {
          content: "";
          position: absolute;
          top: -6px;
          right: 24px;
          width: 12px;
          height: 12px;
          background: #fff;
          transform: rotate(45deg);
          box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.05);
          z-index: -1;
        }
        .popup.visible {
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
        }
      </style>
      <slot name="trigger"></slot>
      <div class="popup">
        <slot name="content"></slot>
      </div>
    `;
  }

  connectedCallback() {
    queueMicrotask(() => this._init());
  }
  
  disconnectedCallback() {
    // 组件移除时清理事件监听
    document.removeEventListener('click', this._outsideClickHandler);
    document.removeEventListener('touchstart', this._outsideClickHandler);
  }

  _init() {
    if (this._isInitialized) return;

    this.triggerEl = this.querySelector('[slot="trigger"]');
    this.popupEl = this.shadowRoot.querySelector('.popup');
    if (!this.triggerEl || !this.popupEl) return;

    this._bindEvents();
    this._observeVisibility();
    this._isInitialized = true;
    this.setAttribute('ready', '');
  }

  _bindEvents() {
    this.triggerEl.addEventListener('mouseenter', () => this._show());
    this.popupEl.addEventListener('mouseenter', () => this._show());
    this.triggerEl.addEventListener('mouseleave', (e) => this._checkHide(e));
    this.popupEl.addEventListener('mouseleave', (e) => this._checkHide(e));
    
    // 阻止trigger的点击事件冒泡到document
    this.triggerEl.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    // 阻止popup内部点击事件冒泡
    this.popupEl.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  _observeVisibility() {
    // 使用 MutationObserver 监听 popup 的 class 变化
    const observer = new MutationObserver(() => {
      const hasOpen = this.popupEl.classList.contains('visible');
      if (hasOpen) {
        this._header.style.zIndex = "100";
        document.documentElement.classList.add('country-modal-open');
        
        // popup显示时添加外部点击监听
        setTimeout(() => {
          document.addEventListener('click', this._outsideClickHandler, true);
          document.addEventListener('touchstart', this._outsideClickHandler, true);
        }, 0);
      } else {
        this._header.style.zIndex = "10";
        document.documentElement.classList.remove('country-modal-open');
        
        // popup隐藏时移除外部点击监听
        document.removeEventListener('click', this._outsideClickHandler, true);
        document.removeEventListener('touchstart', this._outsideClickHandler, true);
      }
    });
    observer.observe(this.popupEl, { attributes: true, attributeFilter: ['class'] });
  }

  _show() {
    this._clearHideTimer();
    this.popupEl.classList.add('visible');
  }

  _checkHide(e) {
    const related = e.relatedTarget;
    if (this.contains(related) || this.shadowRoot.contains(related)) return;
    this._delayedHide();
  }

  _hide() {
    this.popupEl.classList.remove('visible');
  }

  _delayedHide() {
    this._clearHideTimer();
    this._hideTimer = setTimeout(() => this._hide(), 200);
  }

  _clearHideTimer() {
    clearTimeout(this._hideTimer);
  }
  
  _handleOutsideClick(event) {
    // 检查点击是否在组件内部
    const isInsideClick = this._isEventInsideComponent(event);
    
    // 如果点击在外部且popup是可见的，则隐藏
    if (!isInsideClick && this.popupEl.classList.contains('visible')) {
      // 立即隐藏，不延迟
      this._clearHideTimer();
      this._hide();
    }
  }
  
  _isEventInsideComponent(event) {
    // 检查事件目标是否在组件内
    const path = event.composedPath();
    
    // 检查path中是否包含当前组件或shadow root
    for (const element of path) {
      if (element === this || 
          element === this.shadowRoot || 
          element === this.triggerEl ||
          element === this.popupEl) {
        return true;
      }
      
      // 检查是否是slot分配的元素
      if (element instanceof Element) {
        const slotName = element.getAttribute('slot');
        if ((slotName === 'trigger' || slotName === 'content') && 
            element.parentElement === this) {
          return true;
        }
      }
    }
    
    return false;
  }
}

if (!window.customElements.get('hover-popup')) {
  window.customElements.define('hover-popup', HoverPopup);
}
class MediaGridGSAP extends HTMLElement {
    connectedCallback() {
        // 1. 获取所有子项
        this.items = this.querySelectorAll('.media-grid__item');
        if (this.dataset.disableRevealMotion === "true") {
            this._applyStaticState();
            return;
        }
        if (this._revealInitialized) {
            return;
        }
        this._revealInitialized = true;
        
        this._revealTimer = setTimeout(() => {
            this._waitForGsap(0);
        }, 1000);
    }

    disconnectedCallback() {
        clearTimeout(this._revealTimer);
        this._revealInitialized = false;
    }

    /**
     * GSAP and ScrollTrigger load as async CDN scripts in layout/theme.liquid,
     * so they may still be missing after the initial delay. Poll for up to
     * 10 seconds, then fall back to the static state so the items stay visible.
     * @param {number} attempt
     */
    _waitForGsap(attempt) {
        if (window.gsap && window.ScrollTrigger) {
            window.gsap.registerPlugin(window.ScrollTrigger);
            this._initRevealAnimation();
            return;
        }
        if (attempt >= 50) {
            this._applyStaticState();
            return;
        }
        this._revealTimer = setTimeout(() => this._waitForGsap(attempt + 1), 200);
    }

    _applyStaticState() {
        this.items.forEach((item) => {
            item.style.opacity = "1";
            item.style.transform = "";
        });
        this.querySelectorAll(".prose").forEach((item) => {
            item.style.opacity = "1";
            item.style.transform = "";
        });
    }

    _initRevealAnimation() {
        // 使用 fromTo 明确指定从 matrix(1,0,0,1,0,25) 到原位
        gsap.fromTo(this.items, 
            {
                opacity: 0,
                // matrix(a, b, c, d, tx, ty) 
                // 你要求的 ty=25 即 translateY(25px)
                transform: "matrix(1, 0, 0, 1, 0, 25)"
            },
            {
                opacity: 1,
                transform: "matrix(1, 0, 0, 1, 0, 0)",
                duration: 1,
                ease: "power2.out",
                stagger: 0.15, // 每个卡片间隔 0.15秒 出现
                scrollTrigger: {
                    trigger: this,
                    start: "top 85%", // 当组件顶部进入视口 85% 位置时触发
                    toggleActions: "play none none none" 
                },
                onComplete: () => {
                    // 动画完成后清除 transform 属性，避免影响后续的 hover 效果或层级
                    gsap.set(this.items, { clearProps: "transform" });
                }
            }
        );

        // 内部文字的额外浮现效果 (可选，增加精致感)
        const textElements = this.querySelectorAll(".prose");
        gsap.fromTo(textElements, 
            { opacity: 0, y: 10 },
            { 
                opacity: 1, 
                y: 0, 
                duration: 0.8, 
                delay: 0.4, 
                stagger: 0.15,
                scrollTrigger: {
                    trigger: this,
                    start: "top 85%"
                }
            }
        );
    }
};
if (!window.customElements.get("media-grid-gsap")) {
    window.customElements.define("media-grid-gsap", MediaGridGSAP);
}

var ScrollTriggerPinImages = class extends HTMLElement {
    constructor() {
        super();
        this._id = this.getAttribute('sectionId');
    }
    
    connectedCallback() {
        const _this = this;
        
        setTimeout(() => {
            this.querySelectorAll('.accordion-tab-box').forEach((section) => {
                ScrollTrigger.create({
                    trigger: section,
                    start: "top 20%",
                    onEnter: () => switchBanner(section.dataset.target, 'onEnter'),
                    onUpdate: ({progress, direction, isActive}) => handleUpdate(section.dataset.target, {progress, direction, isActive}),
                    // onEnterBack: ({progress, direction, isActive}) => switchBanner(section.dataset.target, 'onEnterBack', {progress, direction, isActive}),
                });
            })
        }, 1000);
        
        function handleUpdate(id, {progress, direction, isActive}) {
            if(isActive && direction === -1 && progress < 0.4) {
                switchBanner(id, 'onEnterBack', {progress, direction, isActive});
            }
        }
        
        function switchBanner(id, type, obj) {
            _this.querySelectorAll(".accodion-card-box-picture").forEach(b => {
                b.classList.remove("active");
                if (b.dataset.banner === id) {
                    b.classList.add("active");
                }
            });
            
            _this.querySelectorAll(".accordion-tab-box").forEach(b => {
                b.classList.remove("active");
                if (b.dataset.target === id) {
                    b.classList.add("active");
                }
            });
        }
    }
    
}
if (!window.customElements.get("scroll-trigger-pin-images")) {
    window.customElements.define("scroll-trigger-pin-images", ScrollTriggerPinImages);
}

var ScrollImageFullToSmall = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    
    const _this = this;
    const pinWrapper = this.querySelector(".pin-wrapper");
    const fullImageWrapper = this.querySelector(".scroll-full-image-wrapper");
    const outerContent = this.querySelector(".outer-content");
    const innerContent = this.querySelector(".inner-content");
    const isMobile = window.innerWidth <= 700 ? true : false;
    
    setTimeout(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: _this,
          start: "top top",
          end: "bottom bottom",
          scrub: true,
          pin: pinWrapper
        }
      });
      
      tl.to(outerContent, {
        opacity: 1,
        duration: 0.3
      }, "<");
      
      tl.to(fullImageWrapper, {
        width: isMobile ? `${window.innerWidth - 40}px` : "1200px",
        height: isMobile ? "200px" : "600px",
        top: "25%",
        duration: 1,
        borderRadius: isMobile ? 8 : 20,
        ease: "power2.out"
      });
      
      tl.to(innerContent, {
        opacity: 1,
        y: -20,
        duration: 0.6
      }, ">");
      
    }, 1000);
    
  }
    
};

if (!window.customElements.get("scroll-image-full-to-small")) {
  window.customElements.define("scroll-image-full-to-small", ScrollImageFullToSmall);
}

var swiperContain = class extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("section-id");
    this.swiperTime = this.getAttribute("swiper-time");
    this.enableAutoPlay = this.getAttribute("enabl-auto-play");

    /* 新增属性 */
    this.setIcon = this.getAttribute("set-icon") === "true";

    const spv = parseFloat(this.getAttribute("slides-per-view"));
    this.slidesPerView = !isNaN(spv) ? spv : null;

    const st = parseFloat(this.getAttribute("stretch"));
    this.stretch = !isNaN(st) ? st : 0;
  }

  connectedCallback() {

    const _sectionId = this.sectionId;
    const _swiperTime = this.swiperTime;
    const _enableAutoPlay = this.enableAutoPlay;
    const _slidesPerView = this.slidesPerView;
    const _stretch = this.stretch;
    const _setIcon = this.setIcon;

    const IS_MOBILE = window.innerWidth < 700;

    function initSwiper() {

      /* ---------------------------
      Progress UI (只有 set-icon=true 才启用)
      --------------------------- */

      let progressDots = [];
      let progressIconImg = null;

      if (_setIcon) {

        progressDots = document.querySelectorAll(
          `#swiper-progress-${_sectionId} .progress-dot`
        );

        const progressIcon = document.getElementById(
          `progress-icon-${_sectionId}`
        );

        progressIconImg = progressIcon
          ? progressIcon.querySelector("img")
          : null;

      }


      function updateProgress(index) {

        if (!_setIcon) return;

        progressDots.forEach((dot, i) => {

          dot.classList.remove("active");

          if (i === index) {

            dot.classList.add("active");

            if (progressIconImg) {

              const icon = dot.getAttribute("data-icon");

              if (icon) {
                progressIconImg.src = icon;
              }

            }

          }

        });

      }


      /* ---------------------------
      Swiper Init
      --------------------------- */

      const slidesView =
        _slidesPerView != null
          ? _slidesPerView
          : (IS_MOBILE ? 1.2 : "auto");

      const swiper = new Swiper(`#myNewSwiper-${_sectionId}`, {

        slidesPerView: slidesView,

        effect: IS_MOBILE ? "slide" : "coverflow",

        grabCursor: !IS_MOBILE,

        coverflowEffect: IS_MOBILE
          ? {}
          : {
              rotate: 0,
              stretch: _stretch || 0,
              depth: 300,
              modifier: 1,
              slideShadows: true,
            },

        spaceBetween: IS_MOBILE ? 10 : 30,

        loop: false,

        allowTouchMove: true,

        slideToClickedSlide: true,

        autoplay: {
          delay: _swiperTime,
          disableOnInteraction: false,
        },

        pagination: {
          el: `#new-swiper-pagination-${_sectionId}`,
          clickable: true,
        },

        navigation: {
          nextEl: `#swiper-button-next-${_sectionId}`,
          prevEl: `#swiper-button-prev-${_sectionId}`,
        },

        on: {

          init: function () {

            if (_setIcon) {
              updateProgress(this.activeIndex);
            }

          },

          slideChange: function () {

            if (_setIcon) {
              updateProgress(this.activeIndex);
            }

            const activeSlide = this.slides[this.activeIndex];

            const newTitle =
              activeSlide.getAttribute("data-title");

            const newDescription =
              activeSlide.getAttribute("data-description");

            const titleElement = document.getElementById(
              `new-swiper-title-${_sectionId}`
            );

            const descriptionElement = document.getElementById(
              `new-swiper-content-${_sectionId}`
            );

            if (!titleElement || !descriptionElement) return;

            titleElement.style.opacity = "0";
            descriptionElement.style.opacity = "0";

            setTimeout(() => {

              titleElement.textContent = newTitle;

              descriptionElement.textContent = newDescription;

              titleElement.style.opacity = "1";

              descriptionElement.style.opacity = "1";

            }, 500);

          },

          slideChangeTransitionEnd: function () {

            if (this.isEnd) {
              console.log("Reached the last slide.");
            }

          }

        },

        breakpoints: {

          768: {
            spaceBetween: 30,
            allowTouchMove: false
          },

          0: {
            spaceBetween: 10,
            allowTouchMove: true
          }

        }

      });


      /* ---------------------------
      Intersection Observer
      --------------------------- */

      const swiperContainer = document.querySelector(
        `#new-swiper-contain-${_sectionId}`
      );

      const swiperPaginationWrap = document.querySelector(
        `#swiper-pagination-wrap-${_sectionId}`
      );

      if (!swiperContainer || !swiperPaginationWrap) return;

      const observer = new IntersectionObserver(

        (entries) => {

          entries.forEach((entry) => {

            if (entry.isIntersecting) {

              if (_enableAutoPlay) {
                swiper.autoplay.start();
              } else {
                swiper.autoplay.stop();
              }

              swiperPaginationWrap.style.position = "fixed";
              swiperPaginationWrap.style.display = "flex";
              swiperPaginationWrap.classList.add("slide-up");

            } else {

              swiper.autoplay.stop();

              swiperPaginationWrap.style.display = "none";
              swiperPaginationWrap.classList.remove("slide-up");

            }

          });

        },

        { threshold: 0.5 }

      );

      observer.observe(swiperContainer);

    }

    window.loadSwiper()
      .then(() => {
        if (this.isConnected) initSwiper();
      })
      .catch((error) => console.error('[swiper-contain] Unable to load Swiper.', error));
  }
};

if (!window.customElements.get("swiper-contain")) {
  window.customElements.define("swiper-contain", swiperContain);
}

class GradientText extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.observer = null;
        this.startTimeout = null;
    }

    static get observedAttributes() {
        return ['colors', 'speed', 'show-border', 'iterations', 'start-delay'];
    }

    connectedCallback() {
        this.render();
        this.setupObserver();
    }

    setupObserver() {
        const once = this.hasAttribute('once');
        const startDelay = parseInt(this.getAttribute('start-delay')) || 0;
        
        const options = {
            root: null,
            // 设定触发区间：只有在屏幕中间 40% 的区域时才显示
            rootMargin: '-30% 0px -30% 0px', 
            threshold: 0
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const container = this.shadowRoot.querySelector('.container');
                
                if (entry.isIntersecting) {
                    // 延迟触发进入动画
                    this.startTimeout = setTimeout(() => {
                        container.classList.add('active');
                        
                        // 计算流光动画结束后的状态
                        const speed = parseFloat(this.getAttribute('speed')) || 3;
                        setTimeout(() => {
                            container.classList.add('end');
                        }, speed * 1000);

                        if (once) this.observer.unobserve(this);
                    }, startDelay);
                } else {
                    // 核心：当滚出中心区域时，移除类名使其隐藏（实现消失效果）
                    if (this.startTimeout) clearTimeout(this.startTimeout);
                    
                    if (!once) {
                        container.classList.remove('active', 'end');
                    }
                }
            });
        }, options);

        this.observer.observe(this);
    }

    render() {
        const colors = this.getAttribute('colors') || `linear-gradient(89deg, #014ACF 0, #325BAC 12.51%, #0183CF 32%, #FFF 84.53%, #FFA100 93.97%)`;
        const speed = this.getAttribute('speed') || "3";
        const iterations = this.getAttribute('iterations') || "infinite";
        const showBorder = this.getAttribute('show-border') === 'true';

        this.shadowRoot.innerHTML = `
        <style>
            :host {
                display: block; /* 改为 block 方便垂直布局内容槽位 */
                text-align: center;
            }

            /* 总容器 */
            .container {
                display: inline-flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                
                /* 初始状态：完全隐藏并下移 */
                opacity: 0;
                transform: translateY(40px);
                transition: opacity 1s cubic-bezier(0.2, 0.8, 0.2, 1), 
                            transform 1s cubic-bezier(0.2, 0.8, 0.2, 1);
                will-change: transform, opacity;
            }

            /* 激活状态：渐变文字显示 */
            .container.active {
                opacity: 1;
                transform: translateY(0);
            }

            .gradient-text {
                font-size: clamp(2rem, 8vw, 5rem);
                font-weight: 700;
                background: ${colors};
                background-size: 300% 100%;
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
                display: inline-block;
                line-height: 1.2;
                animation: none;
            }

            .container.active .gradient-text {
                animation: move-gradient ${speed}s linear;
                animation-iteration-count: ${iterations};
                animation-fill-mode: forwards;
            }
            
            .container.end .gradient-text {
                background-size: 100% 100%;
            }

            /* --- 新增：Content 插槽样式 --- */
            .content-wrapper {
                opacity: 0;
                transform: translateY(20px);
                /* 延迟出现：在渐变文字动画开始后的 0.5s 出现 */
                transition: opacity 1.2s cubic-bezier(0.2, 0.8, 0.2, 1),
                            transform 1.2s cubic-bezier(0.2, 0.8, 0.2, 1);
                transition-delay: 0.5s; 
                margin-top: 1.5rem;
            }

            .container.active .content-wrapper {
                opacity: 1;
                transform: translateY(0);
            }

            @keyframes move-gradient {
                0% { background-position: 0% 50%; }
                100% { background-position: 90% 50%; }
            }

            /* 渐变边框 */
            .border-box {
                display: ${showBorder ? 'block' : 'none'};
                position: absolute;
                inset: -10px -20px;
                border: 2px solid transparent;
                border-radius: 12px;
                background: ${colors} border-box;
                -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
                -webkit-mask-composite: destination-out;
                mask-composite: exclude;
                background-size: 300% 100%;
                opacity: 0.5;
                z-index: -1;
            }

            .container.active .border-box {
                animation: move-gradient ${speed}s linear;
                animation-iteration-count: ${iterations};
            }
        </style>
        
        <div class="container">
            <div class="border-box"></div>
            <div class="gradient-text">
                <slot></slot>
            </div>
            <div class="content-wrapper">
                <slot name="content"></slot>
            </div>
        </div>
        `;
    }

    disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.startTimeout) clearTimeout(this.startTimeout);
    }
}

if (!window.customElements.get("gradient-text")) {
  window.customElements.define("gradient-text", GradientText);
}

class BlurText extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
        // 监听 Slot 变化以提取文字
        this.shadowRoot.querySelector('#text-source').addEventListener('slotchange', () => this.processText());
        this.initObserver();
    }

    // 处理文字拆分 (回归第一版单词下坠逻辑)
    processText() {
        const slot = this.shadowRoot.querySelector('#text-source');
        console.log('== slot: ', slot);
        const target = this.shadowRoot.querySelector('#blur-target');
        const animateBy = this.getAttribute('animate-by') || 'lines';
        const delay = parseInt(this.getAttribute('delay')) || 100;
        
        const rawText = slot.assignedNodes()
            .map(node => node.nodeType === Node.TEXT_NODE ? node.textContent : '')
            .join('').trim();

        if (!rawText) return;
        
        if(animateBy === 'lines') {
            target.innerHTML = `<div class="item">${rawText.replaceAll(/¥/g, '<br>')}</div>`
            
            // 计算内容 Slot 的出现时间
            const contentWrapper = this.shadowRoot.querySelector('.content-wrapper');
            contentWrapper.style.transitionDelay = `${(1 * delay * 0.5) + 400}ms`;
        } else {
            const items = animateBy === 'words' ? rawText.split(/\s+/) : [...rawText];
            
            target.innerHTML = items.map((item, index) => {
                // 1. 如果是特殊换行符 ¥，直接返回换行标签
                if (item === '¥') {
                    return `<br>`;
                }
    
                // 2. 处理空格
                const content = item === ' ' ? '&nbsp;' : item;
                
                // 3. 处理单词模式下的间距
                const spacing = (animateBy === 'words' && index !== items.length - 1) ? '&nbsp;' : '';
    
                // 4. 返回带有动画延迟的 span
                return `<span class="item" style="transition-delay: ${index * delay}ms;">${content}</span>${spacing}`;
            }).join('');
            
            // 计算内容 Slot 的出现时间
            const contentWrapper = this.shadowRoot.querySelector('.content-wrapper');
            contentWrapper.style.transitionDelay = `${(items.length * delay * 0.5) + 400}ms`;
        }


    }
    
    initObserver() {
        const once = this.hasAttribute('once');
        // 获取自定义的延迟启动时间，默认 300ms
        const startDelay = parseInt(this.getAttribute('start-delay')) || 0; 
        
        const trigger = this.closest('.pin-container') || this;
        const container = this.shadowRoot.querySelector('.container');
        
        // 用于存储定时器引用
        this.startTimeout = null;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 如果已经激活且是 once 模式，不再执行
                    if (container.classList.contains('active') && once) return;

                    // 核心：添加延迟执行
                    this.startTimeout = setTimeout(() => {
                        container.classList.add('active');
                        if (once) observer.unobserve(trigger);
                    }, startDelay);

                } else {
                    // 如果滚出视口，清除尚未执行的定时器
                    if (this.startTimeout) {
                        clearTimeout(this.startTimeout);
                    }
                    
                    // 如果不是 once 模式，移除 active 类以便下次重播
                    if (!once) {
                        container.classList.remove('active');
                    }
                }
            });
        }, { threshold: 0.2 });

        observer.observe(trigger);
    }

    render() {
        this.shadowRoot.innerHTML = `
        <style>
            :host { display: block; width: 100%; }
            .container { display: flex; flex-direction: column; align-items: center; width: 100%; }

            h0, h1, h2, h3, h4, h5, h6 {
              margin-block: 0;
            }
            #blur-target {
                // display: flex;
                flex-wrap: wrap;
                justify-content: center;
                font-size: var(--font-size, 5rem);
                font-weight: 700;
                color: var(--blur-color, #fff);
                line-height: 1.1;
                text-align: center;
            }

            /* --- 回归第一版的下坠动效 --- */
            .item {
                display: inline-block;
                opacity: 0;
                // filter: blur(20px);
                // transform: translateY(-60px); /* 从上方坠落 */
                transform: matrix(1, 0, 0, 1, 0, 50);
                transition: 
                    opacity 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s,
                    filter 1s ease-out,
                    transform 1.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s;
                will-change: transform, opacity, filter;
            }

            /* 激活状态 */
            .active .item {
                opacity: 1; 
                transform: matrix(1, 0, 0, 1, 0, 10);
                
                // filter: blur(0px);
                // transform: translateY(0);
            }

            /* 普通内容 Slot 效果 */
            .content-wrapper {
                opacity: 0;
                transform: translateY(30px);
                transition: all 1s cubic-bezier(0.2, 0.8, 0.2, 1);
            }
            .active .content-wrapper {
                opacity: 1;
                transform: translateY(0);
            }

            #text-source { display: none; }
        </style>
        <div class="container">
            <slot id="text-source"></slot>
            <h3 id="blur-target"></h3>
            <div class="content-wrapper">
                <slot name="content"></slot>
            </div>
        </div>
        `;
    }
}

if (!window.customElements.get("blur-text")) {
  window.customElements.define("blur-text", BlurText);
}

class GradientTextGSAP extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
        setTimeout(() => {
            this.initGSAP();
        }, 1000);
    }

    initGSAP() {
        const container = this.shadowRoot.querySelector('.container');
        const title = this.shadowRoot.querySelector('.gradient-text-slot');
        const content = this.shadowRoot.querySelector('.content-wrapper');
        const speed = this.getAttribute('speed') || "3";
        
        // 获取父级 pin-container 作为滚动触发目标
        const trigger = this.closest('.pin-container') || this;

        // 创建 GSAP 时间轴
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: trigger,
                start: "top top",      // 容器顶部到达视口顶部时开始
                end: "bottom bottom",  // 容器底部离开视口底部时结束
                scrub: 1,             // 丝滑滚动同步
                onEnter: () => { title.classList.add('animating'); setTimeout(() => { container.classList.add('end'); }, speed * 1000); },
                onLeaveBack: () => { title.classList.remove('animating'); container.classList.remove('end'); }
            }
        });
        

        // 核心动画序列：中间出现 -> 停留 -> 中间消失
        tl.fromTo(container, 
            { opacity: 0, y: 50 }, 
            { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
        )
        .fromTo(content,
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 1, ease: "power2.out" },
            "-=0.5" // 延迟一点点出现
        )
        .to({}, { duration: 2 }) // 这是一个空档，让文字在中间保持清晰停留一段时间
        .to(container, {
            opacity: 0,
            y: -10,   // 向上飘走并消失
            duration: 1,
            ease: "power2.in"
        });
    }

    render() {
        const colors = this.getAttribute('colors') || `var(--colors)`;
        const speed = this.getAttribute('speed') || "3";
        const iterations = this.getAttribute('iterations') || "infinite";

        this.shadowRoot.innerHTML = `
        <style>
            :host { display: block; }
            .container {
                display: flex; flex-direction: column; align-items: center;
                text-align: center; will-change: transform, opacity;
            }
            .gradient-text-slot {
                font-size: var(--font-size, 5rem);
                font-weight: 700;
                background: ${colors};
                background-size: 300% 100%;
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
                line-height: 1.1;
            }
            /* 流光动画仅在进入视野时播放 */
            .gradient-text-slot.animating {
                animation: flow ${speed}s linear;
                animation-iteration-count: ${iterations};
            }
            .container.end .gradient-text-slot {
                background-size: 100% 100%;
            }
            
            .content-wrapper {
                will-change: transform, opacity;
            }
            @keyframes flow {
                0% { background-position: 0% 50%; }
                100% { background-position: 90% 50%; }
            }
        </style>
        <div class="container">
            <h3 class="gradient-text-slot">
                <slot></slot>
            </h3>
            <div class="content-wrapper">
                <slot name="content"></slot>
            </div>
        </div>
        `;
    }
}

if (!window.customElements.get("gradient-text-gsap")) {
  window.customElements.define("gradient-text-gsap", GradientTextGSAP);
}

var ScrollTriggerTextWithSlides = class extends HTMLElement {
  constructor() {
    super();
    this._id = this.getAttribute('sectionId')
  }

  connectedCallback() {
    const section = document.querySelector(`#st-slides-${this._id}`);
    const text = this.querySelector(`#textOverlay`);
    console.log('===text: ', text);
    
    // const tl = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: section,
    //     pin: section,
    //     anticipatePin: 1,
    //     scrub: 1,
    //     start: 'top top',
    //     end: '400%',
    //   },
    // });
    
    // setTimeout(() => {
      // const tl = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: section,
      //     pin: true,
      //     anticipatePin: 1,
      //     scrub: 1,
      //     start: 'top top',
      //     end: '400%',
      //   },
      // });

      // tl.from(text, {
      //     scale: 20,
      //     ease: 'power1.inOut',
      //   })
      //   .to(text, {
      //     scale: 5,
      //     ease: 'power1.in',
      //     background: '#000000',
      //     duration: 1.5
      //   }, 1);

    // }, 1000);

  }
  disconnectedCallback() {

  }
}
if (!window.customElements.get("scroll-trigger-text-with-slides")) {
  window.customElements.define("scroll-trigger-text-with-slides", ScrollTriggerTextWithSlides);
}

var ScrollTriggerTabs = class extends HTMLElement {
    constructor() {
        super();
        this._id = this.getAttribute('sectionId');
    }
    connectedCallback() {
        const isMobile = window.innerWidth <= 700;
        if(isMobile) return;
        const titleColor = this.getAttribute('title-color');
        const titleActiveColor = this.getAttribute('title-active-color');

        const images = this.querySelectorAll('.accodion-card-box-picture');
        const accordionBox = this.querySelector(`#accordion-tabs-wrap-wrap-${this._id}`);
        const accordionTab = this.querySelector(`#accordion-tabs-contain-${this._id}`);
        const accordionCard = this.querySelector(`#accordion-card-${this._id}`);

        const titles = this.querySelectorAll('.accordion-tab-title');
        const contents = this.querySelectorAll('.accordion-tab-content');
        const constentImages = this.querySelectorAll('.accordion-tab-content-image');
        const dots = this.querySelectorAll('.accordion-tab-dot');
        const tabBoxs = this.querySelectorAll('.accordion-tab-box');

        setTimeout(() => {
          // 固定滚动容器的处理
          function setupAccordionWrap(scrollTriggerConfig) {
              gsap.timeline({
                  scrollTrigger: {
                      ...scrollTriggerConfig
                  }
              });
          }

          // 更新标题、内容和图片的状态
          function updateAccordionContent(index) {
              tabBoxs.forEach((tabBox, i) => {
                tabBox.classList.remove('active');
                if (i === index) {
                  tabBox.classList.add('active');
                }
              })
            
              titles.forEach((title, i) => {
                  title.style.color = i === index ? titleActiveColor : titleColor;
                  // title.style.fontWeight = i === index ? 700 : 500;
              });
              
              if(contents && contents.length > 0) {
                  contents.forEach((content, i) => {
                      // content.style.display = i === index ? "block" : "none";
                      if (i === index) {
                          content.style.display = "block"; 
                          setTimeout(() => content.classList.add('expand'), 100); 
                      } else {
                          content.classList.remove('expand'); 
                          setTimeout(() => content.style.display = "none", 30); 
                      }
                  });
              }
              
              constentImages.forEach((contentImage, i) => {
                  // contentImage.style.display = i === index ? "block" : "none";
                  if (i === index) {
                      contentImage.style.display = "block"; 
                      setTimeout(() => contentImage.classList.add('expand'), 100); 
                  } else {
                      contentImage.classList.remove('expand'); 
                      setTimeout(() => contentImage.style.display = "none", 30); 
                  }
              })

              // dots.forEach((dot, i) => {
              //     dot.style.backgroundColor = i === index ? '#000' : '#D9D9D9';
              // });

              dots.forEach((dot, i) => {
                  if (i === index) {
                      dot.classList.add('dot-active');
                  } else {
                      dot.classList.remove('dot-active');
                  }
              });

              images.forEach((image, i) => {
                  image.style.opacity = i === index ? "1" : "0";
                  image.style.zIndex = i === index ? "2" : "1";
              });
          }

          // 设置图片的滚动动画
          function setupImageScrollAnimation(scrollTriggerBaseConfig) {
              const isMobile = window.innerWidth <= 700;
              if(!isMobile) {
                // 添加标题点击事件
                titles.forEach((title, index) => {
                    title.setAttribute('data-index', index);
                    title.addEventListener('click', () => {
                        updateAccordionContent(index);
  
                        // 使用 scrollIntoView 实现平滑滚动
                        images[index].scrollIntoView({
                            behavior: 'smooth', // 平滑滚动
                            block: 'center', // 滚动后目标元素在视口中居中
                        });
                    });
                });
              }

              // 圆点点击事件
              dots.forEach((dot, index) => {
                  // dot.setAttribute('data-index', index);
                  dot.addEventListener('click', () => {
                      updateAccordionContent(index);

                      // 使用 scrollIntoView 实现平滑滚动
                      images[index].scrollIntoView({
                          behavior: 'smooth', // 平滑滚动
                          block: 'center', // 滚动后目标元素在视口中居中
                      });
                  });
              });
              
              // const stepCount = images.length;
              // let lastIndex = -1;

              // ScrollTrigger.create({
              //   trigger: this,
              //   start: 'top top',
              //   end: '+=300%',
              //   scrub: true,
              //   pin: true,
              //   onUpdate(self) {
              //     const progress = self.progress;
              //     console.log('====progress: ', progress);

              //     const index = Math.min(
              //       stepCount - 1,
              //       Math.floor(progress * stepCount + 0.0001)
              //     );
              //     console.log('====index: ', index);
                  

              //     if (index !== lastIndex) {
              //       lastIndex = index;
              //       updateAccordionContent(index);
              //     }
              //   }
              // });

              const totalHeight = window.innerHeight * 2;
              const stepHeight = totalHeight / images.length;

              images.forEach((image, index) => {
                  gsap.to(image, {
                      scrollTrigger: {
                          ...scrollTriggerBaseConfig,
                          start: `${index * stepHeight}px top`,
                          end: `${(index + 1) * stepHeight}px top`,
                          onEnter: (self) => {
                            // self 包含所有相关信息
                            console.log('===self', self);
                            console.log('onEnter index: ', index);
                            updateAccordionContent(index);
                          },
                          onEnterBack: () => {
                            updateAccordionContent(index);
                            console.log('onEnterBack index: ', index);
                          }
                      },
                      opacity: 1,
                      zIndex: 2
                  });
              });
          }

          function initAccordionWrap() {
            // const isMobile = window.innerWidth <= 700;
            // if(isMobile) {
            //   updateAccordionContent(0);
              
            //   // 添加标题点击事件
            //   titles.forEach((title, index) => {
            //       title.setAttribute('data-index', index);
            //       title.addEventListener('click', () => {
            //           updateAccordionContent(index);

            //           // 使用 scrollIntoView 实现平滑滚动
            //           images[index].scrollIntoView({
            //               behavior: 'smooth', // 平滑滚动
            //               block: 'center', // 滚动后目标元素在视口中居中
            //           });
            //       });
            //   });
            //   return;
            // }
              // 主逻辑
              setupAccordionWrap(
                  {
                      trigger: accordionBox,
                      start: 'top top',
                      end: 'bottom top',
                      scrub: true
                  },
                  accordionTab
              );
          
              setupImageScrollAnimation({
                  trigger: accordionCard,
                  scrub: false
              });

              updateAccordionContent(0);
          }

          initAccordionWrap();

          window.addEventListener('resize', () => {
              initAccordionWrap();
          });
        }, 2000);
    }
}
if (!window.customElements.get("scroll-trigger-tabs")) {
  window.customElements.define("scroll-trigger-tabs", ScrollTriggerTabs);
}